export const tokens = {
    common: {
        no_unassigned_sales_channel: '미배정 발주처가 없습니다.',
        sales_channel_id_sales_channel_address: '발주처ID, 발주처, 주소',
        unassigned_list: '미배정 리스트',
        number_of_sales_channels_monthly_average_order_total: '{{totalSales}}개 발주처 / 월평균 주문금액 총 {{totalAvgAmt}} 원',
        count: '개',
        assigned_sales_office_id: '배정 발주처 ID',
        sales_office_id_contact_driver_name_assigned_route: '발주처ID, 기사연락처, 기사명, 배정 라우트',
        manager_id: '매니저 ID',
        view_unassigned_managers_only: '미배정 매니저만 보기',
        business_registration_number: '사업자번호',
        vehicle_unit: '대',
        urgent_dispatch_vehicle: '긴급배차 {{emrgDsptCnt}} 대',
        max_pinned_notices: '고정 공지는 최대 6개까지 등록 가능합니다.',
        notice: '공지사항',
        notice_details: '공지사항 상세',
        notice_termination_completed: '공지사항 종료가 완료되었습니다.',
        category_required: '카테고리는 필수입니다',
        fixed: '고정',
        list: '목록',
        return_exchange_code: '반품&교환코드',
        no_return_exchange_history: '반품&교환 이력이 없습니다.',
        incomplete_return_exchange_history_only: '미완료 반품 & 교환 이력만 보기',
        return_exchange_history: '반품 & 교환 이력',
        incomplete: '미완료',
        sales_place_info_4: '발주처ID, 발주처, 반품&교환코드, 상세 내용',
        sales_place_info_3: '발주처ID, 발주처, 상세 내용',
        sales_place_info_2: '발주처ID, 발주처, 사업자번호',
        send_sms: '문자 발송',
        no_claim_history_exists: '클레임 이력이 존재하지 않습니다.',
        view_unprocessed_claims_only: '미처리 클레임만 보기',
        sales_office_id_sales_office_consultation_content: '발주처ID, 발주처, 상담 내용',
        claim_history: '클레임 이력',
        minimum_length_9_digits_required: '9자리 이상 입력하여 주십시오',
        representative_name_length_limit: '대표자명은 25자리 이하로 입력하여 주십시오.',
        corporation_name_required: '거래법인명은 필수 입니다.',
        trading_corporation_id: '거래법인 ID',
        trading_corporation_info: '거래법인ID, 거래법인, 사업자상호, 사업자번호',
        unused: '미사용',
        not_in_use: '미사용중',
        required: '필요',
        sales_outlet_registration: '발주처 등록',
        sales_outlet_update: '발주처 수정',
        error_occurred_during_sales_outlet_save_or_update: '발주처 저장/수정중 오류가 발생했습니다.',
        error_while_saving_or_updating_sales_outlet: '발주처 저장/수정 중 에러',
        settlement_payment_month_required: '정산 결제월은 필수 입니다',
        sales_place_info: '발주처ID, 발주처, 발주처코드',
        contract_date_is_required: '계약일자는 필수입니다.',
        purchase_manager_selection_is_required: '구매담당자 선택은 필수 입니다.',
        registered_product_count: '등록상품수',
        purchase_place_info: '브랜드ID, 브랜드, 사업자상호, 사업자번호, 대표자',
        public_holiday_name_input: '공휴일명 입력',
        holiday_start_end_date: '공휴일시작/종료일',
        end_of_month_payment: '말일 결제',
        contract_start_end_date: '계약시작/종료일',
        trading_corporation: '거래법인',
        cannot_exceed_5_characters: '5자리를 넘을 수 없습니다.',
        enter_up_to_20_characters: '20자리 이하로 입력하여 주십시오.',
        enter_contact_person_2_name_phone_email: '담당자2 저장하고 싶다면 이름,연락처,이메일 모두 입력해주세요.',
        brandID_brand_business_number_representative: '브랜드ID, 브랜드, 사업자번호, 대표자',
        contract_termination_completed: '계약종료 처리 되었습니다.',
        code_group_deletion_completed: '코드 그룹 삭제가 완료 되었습니다.',
        select_category_change: '변경할 카테고리 선택',
        category_classification: '카테고리 구분',
        count_product: '개 상품',
        category_name_required: '카테고리명은 필수 입니다.',
        category_name_50: '카테고리명은 50자를 넘을 수 없습니다.',
        category_name_required_n: '카테고리명은 필수 입니다 카테고리명은 n자를 넘을 수 없습니다',
        category_name_duplicate: '카테고리명이 중복되었습니다.',
        category_code_duplicate: '카테고리 코드가 중복되었습니다',
        additional_fee: '가산', // 명확하게 가산으로 변경
        additional_payment_amount: '가산 지급액', // 가산 지급액을 명확하게
        virtual_account_transaction_history: '가상계좌 거래내역 조회',
        no_virtual_account_transaction: '가상계좌 거래내역이 존재하지 않습니다',
        manage_virtual_accounts: '가상계좌 관리',
        virtual_account_bulk_registration_completed: '가상계좌 대량 등록이 완료 되었습니다',
        virtual_account_number: '가상계좌 번호',
        virtual_account_number_registration: '가상계좌 번호 등록',
        virtual_account_deletion: '가상계좌 삭제',
        virtual_account_deletion_completed: '가상계좌 삭제가 완료 되었습니다',
        virtual_account_file: '가상계좌 파일',
        virtual_account_cancellation_approval: '가상계좌 해지 승인',
        virtual_account_cancellation_error: '가상계좌 해지 중 오류가 발생했습니다',
        virtual_account_cancellation_completed: '가상계좌 해지가 완료 되었습니다',
        virtual_account_sales_name: '가상계좌번호 발주처 발주처명',
        no_virtual_account_information: '가상계좌정보가 존재하지 않습니다',
        available_stock: '가용 재고',
        available_stock_quantity: '가용 재고 수량',
        available_inventory_stock: '가용재고',
        stock_holding: '재고홀딩',
        stock_holding_quantity: '재고 보유 수량',
        holding_quantity: '현재 홀딩 수량',
        stock_holding_warning_1: '재고를 홀딩하는 경우 지정한 수량만큼 주문이 불가능 하니,',
        stock_holding_warning_2: '다시 한번 신중하게 ',
        stock_holding_warning_3: '확인 후 진행',
        stock_holding_warning_4: '하시기 바랍니다.',
        individual_brand_sale_price: '각 브랜드의 상위 그룹 에서 개별 설정한 판매가',
        individual_brand_center_sale_price: '각 브랜드의 출차 센터별 개별 설정한 판매가',
        trunk_main: '간선',
        trunk_label_printing: '간선 PLT 라벨 출력',
        trunk_route: '간선 라우트',
        trunk_route_detail: '간선 라우트 상세',
        trunk_inbound: '간선 입고',
        trunk_inbound_detail: '간선 입고 상세',
        trunk_plt_printing: '간선 PLT 출력',
        trunk_route_modification: '간선라우트 수정',
        trunk_shipment: '간선출고',
        trunk_code: '간선코드',
        forced_inbound: '강제 입고',
        forced_inbound_registration: '강제 입고 등록',
        forced_inbound_processing_confirmation: '강제 입하처리 확인',
        forced_entry_registration: '강제입고등록',
        forced_arrival_processing: '강제입하처리',
        average_monthly_order_amount: '발주처 월평균 주문금액 총 원',
        not_confirmed_statement_included: '미확정 정산서가 아닌 정산서가 포함되어 있습니다. 다시 선택해주시기 바랍니다',
        confirmed_statement_included: '미확정 정산서가 포함되어 있습니다. 다시 선택해주시기 바랍니다',
        product: '상품',
        assigned_quantity: '할당수량',
        box_unit: '박스',
        individual_picking_label_printing: '개별 피킹지 출력',
        individual_setting_classification: '개별설정구분',
        individual_picking_paper_printing: '개별피킹지 출력',
        init_date: '개시일',
        confirm_early_shipment: '개의 상품을 선출고 지시 하시겠습니까',
        confirm_shipment: '선택하신 {{totalConfirmShipment}}개의 상품을 출고 지시 하시겠습니까?\n\n',
        adjustment_details: '개의 조정금 처리 내역',
        transaction_amount: '거래 금액',
        transaction_corporation: '거래 법인',
        transaction_classification: '거래구분',
        trading_volume: '거래량',
        transaction_statement_receipt_method: '거래명세서 수취 방식',
        transaction_statement_recipient: '거래명세서 수취인',
        transaction_statement_printing: '거래명세서 출력',
        transaction_statement_printing_options: '거래명세서 출력 - 옵션선택',
        transaction_volume: '거래물량',
        company: '본사',
        company_selection_required: '본사 선택은 필수 입니다',
        trading_corporation_management: '본사 관리',
        trading_corporation_registration: '본사 등록',
        select_trading_corporation: '거래법인 선택',
        trading_corporation_selection_required: '거래법인 선택은 필수 입니다',
        trading_corporation_edit_and_registration: '거래법인 수정',
        trading_corporation_name_input: '거래법인명은 30자리 이하로 입력하여 주십시오',
        duplicate_trading_corporation_name: '거래법인명이 중복되었습니다',
        trading_corporation_required: '거래법인은 필수 입니다',
        transaction_type: '거래유형',
        trading_date: '거래일',
        transaction_serial_number: '거래일련번호',
        transaction_date_time: '거래일시',
        transaction_date: '거래일자',
        post_transaction_balance: '거래후 잔액',
        case_count: '건',
        case_processing: '건씩 처리',
        delete_faq_prompt: '건의 자주 묻는 질문을 삭제하려면 비밀번호를 입력하세요',
        search: '검색',
        no_search_results: '검색 결과 없음',
        search_results: '검색 결과 입니다',
        search_area: '검색 영역',
        no_searched_history: '검색된 내역이 없습니다',
        enter_search_term: '검색어를 입력 하세요',
        required_payment_month: '결재월은 필수 입니다',
        required_payment_date: '결재일은 필수 입니다',
        monthly_payment: '결제 매월 일',
        payment_amount_1: '결제금액',
        payment_status: '결제상태',
        overdue_payment_only: '결제상태 미납 내역만 보기',
        payment_based_on_month: '결제월기준',
        payment_date: '결제일',
        payment_date_adjustment: '결제일 조정',
        warning: '경고',
        gyeongnam: '경남',
        stopover: '경유지',
        contract: '계약',
        contract_date: '계약일',
        contract_status: '계약 상태',
        contract_start_and_end_date: '계약 시작 / 종료일',
        contract_start_date_required: '계약 시작일은 필수 입니다',
        contract_information: '계약 정보',
        contract_termination: '계약 종료',
        contract_termination_password_required: '계약 종료 처리를 원하시는 경우 비밀번호를 입력해주세요',
        contract_end_date: '계약 종료일',
        contract_end_date_required: '계약 종료일은 필수 입니다',
        contract_attached_documents: '계약 첨부 서류',
        contract_type: '계약 형태',
        contract_type_payment_date: '계약 형태 / 결제일',
        contract_type_collateral_type: '계약 형태 / 담보 유형',
        contract_type_required: '계약 형태는 필수 입니다',
        account_password: '계정 비밀번호',
        account_password_required: '계정 비밀번호는 입력 필수입니다',
        account_registration: '계좌 등록',
        account_cancellation: '계좌 등록/해지',
        account_deletion: '계좌 삭제',
        account_balance: '계좌 잔액',
        account_issuance_date: '계좌발급일시',
        account_number: '계좌번호',
        account_number_required: '계좌번호는 필수 입니다',
        account_status: '계좌상태',
        customer_list_1: '고객 리스트',
        customer_consultation_details: '고객 상담 상세',
        customer_consultation_history: '발주처 상담 이력',
        customer_notice_completed: '고객 안내 완료 체크는 필수입니다',
        fix_notice: '고정 공지로 등록하기',
        fixed_sale_price_input: '고정 판매가 입력',
        fixed_price: '고정가',
        fixed_price_recommendation: '고정가(권장판매가)',
        fixed_price_required: '고정가는 필수입니다',
        supplier_information: '공급자 정보',
        notification_registration: '공지 등록',
        notification_termination: '공지 종료',
        notice_contents: '공지내용',
        announcement_management: '공지사항 관리',
        announcement_termination_password_required: '공지사항 노출을 종료하려면 비밀번호를 입력하세요',
        public_holiday_period: '공휴일 기간',
        public_holiday_date_selection_required: '공휴일 날짜 선택은 필수 입니다',
        public_holiday_registration: '공휴일 등록',
        public_holiday_name: '공휴일명',
        public_holiday_name_required: '공휴일명은 필수 입니다',
        taxation_status: '과세여부',
        tax_inclusion: '과세 시 부가세 포함',
        exchange_return_screen: '교환 반품 접수 화면',
        exchange_processing_new_order_required: '교환 처리 시 신규 주문을 반드시 등록해주세요',
        purchase_manager: '담당자',
        purchase_manager_information: '담당자 정보',
        purchase_manager_search: '담당자 검색',
        search_select_purchase_manager: '담당자를 검색/선택 해주세요',
        purchase_profit_rate: '구매이익율',
        purchase_profit_rate_prompt: '구매이익율 입력',
        purchase_profit_rate_change_reservation_completed: '구매이익율 변경 예약이 완료 되었습니다',
        division: '구분',
        classification_code_required: '구분코드 선택은 필수 입니다',
        zone: '구역',
        variable_assignment_with_destructuring: '구조 분해 할당을 통해 변수 설정',
        select_nation: '국가 선택',
        country_required: '국가는 필수 입니다',
        citizens: '국민',
        recommended_price: '권장 판매가',
        set_recommended_price: '권장 판매가 설정',
        recommended_selling_price: '권장판매가',
        recommended_selling_price_settings: '권장판매가설정구분',
        authority_group: '권한 그룹',
        select_authority_group: '권한 그룹 선택',
        authority_group_required: '권한 그룹은 필수입니다',
        permission_group: '권한그룹',
        attribution: '귀책',
        attribution_amount: '귀책 금액',
        attribution_selection: '귀책 선택',
        attribution_selection_required: '귀책 선택은 필수 입니다',
        attributable_amount: '귀책금액',
        your_fault_required: '귀책은 선택 필수입니다',
        your_fault_mandatory: '귀책은 필수입니다',
        select_fault: '귀책을 선택하세요',
        specifications: '규격',
        specifications_required: '규격은 필수 입니다',
        enter_specifications: '규격입력',
        regulation: '규제',
        set_regulation_period: '규제 기간 설정',
        future_date_only_for_regulation: '규제 기간은 미래 날짜로만 등록 가능합니다',
        bulk_regulation: '규제 대량 등록',
        regulation_status: '규제 상태',
        view_regulation_items_only: '규제 설정 상품만 보기',
        regulation_timestamp: '규제 설정일시',
        regulation_termination: '규제 종료',
        irreversible_regulation_termination: '규제 종료 처리 시에는 데이터 원복이 불가합니다',
        regulation_period: '규제기간',
        regulation_start: '규제시작',
        regulation_scheduled: '규제예정',
        regulation_end: '규제종료',
        regulation_in_progress: '규제중',
        proceed_anyway: '그래도 진행 하시겠습니까',
        proceed_with_process: '그래도 처리하시겠습니까',
        cancel_recovery: '그래도 회수를 취소하시겠습니까',
        gold: '금',
        amount: '금액',
        amount_change_history: '금액 변경 이력',
        enter_amount: '금액 입력',
        amount_required: '금액 입력은 필수 입니다',
        period: '기간',
        period_regulation: '기간 규제',
        register_period_regulation: '기간 규제 등록',
        period_inquiry: '기간 조회',
        period_regulation_status: '기간규제여부',
        period_query: '기간조회',
        function: '기능',
        final: '기말',
        basic: '기본',
        basic_info: '기본 정보',
        basic_profit_rate: '기본 판매 이익율',
        basic_rate_of_profit: '기본이익율',
        enter_driver_details: '기사님 이름과 전화번호를 입력해주세요',
        existing_contract_restoration: '기존 계약정보가 원복 되오니',
        standard_recommended_price: '기준 권장판매가',
        reference_date: '기준일',
        reference_date_price: '기준일 판매가',
        foundation: '기초',
        emergency_dispatch_driver_registration: '긴급 배차 기사 등록',
        emergency_dispatch_driver_registration_complete: '긴급 배차 기사가 등록이 완료 되었습니다',
        emergency_shipment: '긴급 출고',
        emergency_shipment_detail: '긴급 출고 상세',
        emergency_shipment_request_complete: '긴급 출고 신청이 완료되었습니다',
        emergency_shipment_complete: '긴급 출고 완료 되었습니다',
        no_emergency_shipment_requests: '긴급 출고 요청 내역이 없습니다',
        cancel_emergency_shipment_request: '긴급 출고 요청 취소',
        emergency_shipment_history: '긴급 출고 이력',
        emergency_shipment_registration: '긴급 출고 접수',
        emergency_shipment_processing: '긴급 출고 처리',
        emergency_shipment_issue_processing: '긴급 출고 처리 이슈 처리',
        emergency_dispatch: '긴급배차',
        emergency_dispatch_driver: '긴급배차 기사',
        emergency_dispatch_driver_contact: '긴급배차 기사 연락처',
        no_emergency_dispatch_records: '긴급배차 내역이 없습니다',
        emergency_dispatch_registration: '긴급배차 등록',
        emergency_dispatch_route: '긴급배차 라우트',
        emergency_dispatch_list: '긴급배차 리스트',
        emergency_dispatch_cost: '긴급배차 비용',
        emergency_dispatch_status: '긴급배차여부',
        urgent_delivery: '긴급출고',
        urgent_delivery_1: '긴급 출고',
        no_urgent_delivery_records: '긴급출고 내역이 없습니다',
        urgent_delivery_shipment_label: '긴급출고 배송 표시',
        urgent_delivery_cost: '긴급출고 비용',
        urgent_delivery_detail: '긴급출고 상세',
        urgent_delivery_item_count: '긴급출고 상품수',
        no_urgent_delivery_history: '긴급출고 이력이 없습니다',
        emergency_delivery_cost_required: '긴급출고시 배송 비용은 입력 필수입니다',
        emergency_delivery_contact_required: '긴급출고시 배송기사 전화번호는 입력 필수입니다',
        urgent_delivery_date: '긴급출고일',
        view_my_claim_history: '나의 담당 클레임 이력만 보기',
        view_my_urgent_shipment_history: '나의 상담 긴급출고 이력만 보기',
        view_my_pending_cases: '나의 처리중 내역만 보기',
        date_1: '날짜',
        date_selection_start_end: '날짜 선택 (시작 -> 종료)',
        payment_deadline_extension: '납부 기한 연장',
        payment_deadline_extension_notice: '납부 기한 연장 시 연장 종료일까지 미납 처리가 유예 됩니다',
        payment_deadline_extension_end_date: '납부 기한 연장 종료일',
        payment_extension: '납부 연장',
        payment_amount_2: '납부금액',
        payment_due_date: '납부기한',
        payment_due_date_required: '납부기한 연장 종료일은 필수 입니다',
        payment_extension_completed: '납부기한 연장이 완료 되었습니다',
        my_notifications_only: '내가 등록한 공지만 보기',
        history_quantity_and_amount: '내역 수량 금액',
        content: '내용',
        no_content: '내용 없음',
        content_max_length: '내용은 2000자 이내 입니다',
        content_max_length_prompt: '내용은 자 이내로 입력해 주세요',
        content_required: '내용은 필수입니다',
        tomorrow: '내일',
        frozen: '냉동',
        refrigerated: '냉장',
        year_month: '년 월',
        annual_disposal_rate: '년간 폐기율',
        exposure: '노출',
        exposure_change: '노출 변경',
        exposure_period: '노출기간',
        exposure_change_completed: '노출변경이 완료 되었습니다',
        exposure_status_change: '노출상태 변경',
        cumulative_arrears: '누적 미납금액',
        double_check_file: '다시 한번 파일을 확인해주시기 바랍니다',
        double_check_and_proceed: '다시 한번 확인 후 처리 해주시기 바랍니다',
        file_name_to_download: '다운로드될 파일명',
        unit_price: '단가',
        unit_price_order_information: '단가・발주 정보',
        no_unit_price_change_history: '단가 변경 내역이 없습니다',
        unit_price_change_date_time: '단가 변경 일시',
        unit_price_change_info: '단가 변경 정보',
        unit_price_information: '단가 정보',
        unit_price_adjustment_history: '단가 조정이력 조회',
        unit_price_history: '단가 히스토리',
        unit_price_application_date_selection: '단가적용일 선택',
        unit: '단위',
        unit_specifications: '단위 규격',
        close: '닫기',
        chicken_breast: '닭가슴살 하림',
        person_in_charge: '담당자',
        person_in_charge_selection: '담당자 선택',
        person_in_charge_contact: '담당자 연락처',
        person_in_charge_contact_required: '담당자 연락처 필수입니다',
        person_in_charge_contact_prompt: '담당자 연락처는 필수 입니다',
        person_in_charge_contact_max_length_prompt: '담당자 연락처는 11자리 이하로 입력하여 주십시오',
        person_in_charge_email: '담당자 이메일',
        person_in_charge_email_required: '담당자 이메일은 필수 입니다.',
        person_in_charge_email_required_2: '이메일형식이 올바르지 않습니다',
        save_person_in_charge_info: '담당자 저장하고 싶다면 이름 연락처 이메일 모두 입력해주세요',
        person_in_charge_information: '담당자 정보',
        enter_person_in_charge_info: '담당자 정보를 입력 해주세요',
        name_of_person_in_charge_required: '담당자명은 20자리 이하로 입력하여 주십시오',
        name_of_person_in_charge_required_short: '담당자명은 필수입니다',
        collateral_start_end_date: '담보개시 / 종료일',
        collateral_start_date_required: '담보 개시일은 필수 입니다',
        collateral_amount_required: '담보 설정금액은 필수 입니다',
        collateral_type_amount: '담보 유형 / 설정 금액',
        collateral_end_date_required: '담보 종료일은 필수 입니다',
        collateral_commencement: '담보개시',
        collateral_status: '담보상태',
        collateral_type: '담보유형',
        collateral_credit_limit: '담보유형 / 여신한도',
        collateral_type_required: '담보유형은 필수 입니다',
        collateral_termination: '담보종료',
        answer: '답변',
        answer_required: '답변은 필수입니다',
        this_month_inbound: '당월 입고',
        this_month_outbound: '당월 출고',
        delivery_status_today: '당일 배송 현황',
        daegu_branch: '대구분',
        standby: '대기',
        large_company_usage: '대기업 사용 여부',
        large_company_integration_needed: '대기업 연동 필요 여부',
        large_company_code_entry: '대기업 코드 입력',
        corporate_code_and_large_company_required: '대기업과 대기업코드는 필수 입니다',
        large_company_sales_code: '대기업발주처코드',
        large_company_usage_status: '대기업사용여부',
        large_company_product_code: '대기업상품코드',
        large_company_product_code_required: '대기업상품코드는 필수 입니다',
        large_company_integration_needed_status: '대기업연동필요여부',
        duplicate_large_company: '대기업은 중복될 수 없습니다',
        large_company_code: '대기업코드',
        duplicate_corporate_code: '대기업코드는 중복될 수 없습니다',
        corporate_code_required: '대기업코드는 필수 입니다',
        bulk_upload: '대량 업로드',
        bulk_registration: '대량등록',
        uppercase_only: '대문자만 입력 가능합니다',
        major_category: '대분류',
        major_category_selection: '대분류 선택',
        major_category_middle_category: '대분류 - 중분류',
        major_category_required: '대분류 카테고리는 필수입니다',
        major_category_required_short: '대분류는 필수 입니다',
        representative_email: '대표 이메일',
        representative_email_address_1: '대표 이메일 주소',
        representative_email_required_1: '대표 이메일은 필수 입니다.',
        representative_email_required_2: '대표 이메일형식이 올바르지 않습니다',
        representative_email_format_invalid: '대표 이메일은 필수 입니다 이메일 형식이 맞지 않습니다',
        representative_email_address_2: '대표이메일주소',
        representative: '대표자',
        representative_contact: '대표자 연락처',
        representative_contact_required_2: '대표자 연락처는 필수 입니다',
        representative_contact_prompt: '대표자 연락처는 11자리 이하로 입력하여 주십시오',
        representative_name: '대표자 이름',
        representative_name_contact: '대표자 이름 / 연락처',
        representative_name_required: '대표자 이름은 필수 입니다',
        representative_name_prompt: '대표자 이름은 25자리 이하로 입력하여 주십시오',
        representative_email_required: '대표자 이메일은 필수 입니다',
        same_as_representative_info: '대표자 정보 동일',
        representative_full_name: '대표자명',
        representative_contact_info: '대표자연락처',
        representative_name_short: '대표자이름',
        see_more: '더보기',
        data_too_large_for_excel_download: '데이터가 많아서 엑셀 다운로드가 어렵습니다',
        data_invalid: '데이터가 유효하지 않습니다',
        door_lock: '도어락',
        arrival_location_code: '도착 로케이션 코드',
        arrival_center: '도착센터',
        destination: '도착지',
        destination_contact_name_prompt: '도착지 담당자명은 50자리 이하로 입력해주세요',
        destination_contact_name_max_length: '도착지 담당자명은 최고 2자리를 입력해주세요',
        destination_contact_name_required: '도착지 담당자명을 필수로 입력해주세요',
        destination_center_required: '도착지 센터를 필수로 선택해주세요',
        destination_contact_required: '도착지 연락처를 필수로 입력해주세요',
        destination_information: '도착지 정보',
        destination_address: '도착지 주소',
        destination_center: '도착지센터',
        dock_number: '도크 번호',
        dongicheon: '동이천',
        same_purchase_vendor_settlement: '동일한 브랜드의 매입 내역만 정산서 생성이 가능합니다 확인 후 다시 선택해 주시기 바랍니다',
        same_sales_vendor_assigned: '동일한 발주처가({{salesPlace}}) 배정되어 있습니다',
        same_brand_sales_only: '동일한 브랜드 내 연결 발주처에 한하여 가능합니다',
        cannot_select_same_time: '동일한 시간을 선택할 수 없습니다 다시 선택해 주세요',
        registration: '등록',
        registration_completed: '등록 되었습니다',
        registered_product: '등록 상품',
        registered_product_order_history_excel_download: '등록 상품 주문 내역 엑셀 다운로드',
        registration_edit: '등록/수정',
        registration_confirmation_needed: '등록 후 반드시 확인',
        no_registered_corporation: '등록된 거래법인이 없습니다',
        no_registered_notifications: '등록된 공지사항이 없습니다',
        no_registered_locations: '등록된 로케이션이 없습니다',
        no_registered_managers: '등록된 매니저가 없습니다',
        no_registered_sales_clients: '등록된 발주처가 없습니다',
        no_registered_brands: '등록된 거래처가 없습니다',
        no_registered_consultation_history: '등록된 상담이력이 없습니다',
        no_registered_product_regulations: '등록된 상품 규제가 존재하지 않습니다',
        no_registered_products: '등록된 상품이 없습니다',
        no_registered_faqs: '등록된 자주 묻는 질문이 없습니다',
        no_registered_inventory_history: '등록된 재고 이력이 없습니다',
        no_registered_inventory_adjustment_history: '등록된 재고 조정 내역이 없습니다',
        no_registered_inventory_items: '등록된 재고 항목이 없습니다',
        no_registered_inventory_audit_history: '등록된 재고조사 내역이 없습니다',
        no_registered_inventory_audit_items: '등록된 재고조사 항목이 없습니다',
        registration_date: '등록일',
        registration_timestamp: '등록일시',
        registrant: '등록자',
        careful_before_registration: '등록전에 신중히 고려 후 등록해주세요',
        label: '라벨',
        label_generation: '라벨 생성',
        no_label_generation_or_quantity_invalid: '라벨 생성할 대상이 없거나 라벨 수량을 으로 입력한 것은 발행하지 않습니다',
        label_quantity: '라벨 수량',
        label_quantity_count: '라벨수 개',
        label_reprint: '라벨 재출력',
        label_printing: '라벨 출력',
        print_label: '라벨을 출력 하시겠습니까?',
        label_print_button: '[PLT라벨 출력] 버튼으로 라벨 생성 작업을 하십시요',
        label_code: '라벨 코드',
        number_of_labels: '라벨수',
        route: '라우트',
        route_management: '라우트 관리',
        route_list: '라우트 리스트',
        route_assignment: '라우트 배정',
        route_assignment_completed: '라우트 배정이 완료 되었습니다',
        route_deletion: '라우트 삭제',
        route_details: '라우트 상세',
        route_selection: '라우트 선택',
        route_addition: '라우트 추가',
        no_route: '라우트가 없습니다',
        route_deletion_confirmation: '라우트를 삭제하시겠습니까',
        route_name: '라우트명',
        route_name_entry: '라우트명을 입력하고 저장해주세요',
        route_name_required: '라우트명을 입력해주세요',
        route_assignment_short: '라우트배정',
        lag: '렉',
        log_out: '로그아웃',
        log_out_button: '로그아웃 시 이 버튼을 눌러주세요',
        location_management: '로케이션 관리',
        location_classification: '로케이션 구분',
        location_zone: '로케이션 구역',
        location_label_printing: '로케이션 라밸 출력',
        location_label_reprinting: '로케이션 라벨 재출력',
        location_label_printing_short: '로케이션 라벨 출력',
        location_list: '로케이션 리스트',
        location_alias: '로케이션 명칭',
        location_barcode_scan: '로케이션 바코드를 찍고 로케이션 정보를 등록해주세요',
        location_details: '로케이션 상세',
        location_option: '로케이션 옵션',
        location_position: '로케이션 위치',
        location_auto_sort: '로케이션 위치 순으로 자동 정렬 됩니다',
        location_name: '로케이션 이름',
        location_name_input: '로케이션 이름 입력',
        location_name_prompt: '로케이션 이름을 입력해주세요',
        location_add: '로케이션 추가',
        location_code: '로케이션 코드',
        location_code_product_name: '로케이션 코드 상품명',
        location_label_code: '로케이션라벨 코드',
        location_label_location_code: '로케이션라벨 코드 로케이션 코드',
        location_status: '로케이션상태',
        location_disposal_qty: '로케이션의 폐기 예정 수량만 표시',
        location_address: '로케이션주소',
        create_prompt: '를 생성해주세요',
        select_prompt: '를 선택해주세요',
        exclude_shipment_processed: '를 제외한 출고를 정상 출고 처리 했습니다',
        lead_time: '리드타임',
        lead_time_prevention: '리드타임 이면 당일입고 막기 위함',
        lead_time_required: '리드타임은 필수 입니다',
        input_only: '만 입력',
        word: '말',
        end_of_month: '말일',
        tax_and_non_tax: '면/과세',
        tax: '과세',
        non_tax: '면세',
        manager: '매니저',
        manager_search: '매니저 검색',
        manager_management: '매니저 관리',
        manager_detail: '매니저 상세',
        manager_selection: '매니저 선택',
        manager_update: '매니저 수정',
        manager_registration: '매니저 등록',
        manager_name: '매니저 이름',
        manager_name_contact: '매니저 이름 / 연락처',
        manager_name_below_limit: '매니저 이름은 자리 50이하로 입력해주세요',
        manager_name_above_limit: '매니저 이름은 최고 2자리를 입력해주세요',
        manager_name_required: '매니저 이름을 필수로 입력해주세요',
        manager_phone: '매니저, 전화번호',
        manager_info: '매니저 정보',
        manager_management_overview: '매니저관리',
        search_select_manager: '매니저를 검색/선택 해주세요',
        register_manager_prompt: '매니저를 등록 해주세요',
        select_manager_prompt: '매니저를 선택해주세요',
        select_manager_required: '매니저를 필수로 선택해주세요',
        manager_name_label: '매니저명',
        manager_name_alternate: '매니저이름',
        manager_save: '매니저저장',
        manager_info_overview: '매니저정보',
        every_month: '매월',
        settlement_start_date: '매월 정산이 시작되는 기준일',
        purchase_period: '매입 기간',
        purchase_details: '매입 내역',
        purchase_count: '매입 내역 갯수',
        purchase_positive_details: '매입 양수 내역',
        no_purchase_positive_details: '매입 양수 내역이 존재하지 않습니다',
        purchase_settlement: '매입 정산',
        purchase_invoice_resend_complete: '매입 정산서 메일 재전송이 완료 되었습니다',
        purchase_invoice_delete: '매입 정산서 삭제',
        purchase_invoice_delete_complete: '매입 정산서 삭제가 완료 되었습니다',
        purchase_invoice_edit_complete: '매입 정산서 수정이 완료되었습니다',
        purchase_invoice_confirm_all: '매입 정산서 일괄 확정',
        purchase_invoice_confirm: '매입 정산서 확인',
        purchase_invoice_finalize: '매입 정산서 확정',
        purchase_invoice_finalize_complete: '매입 정산서 확정이 완료 되었습니다',
        total_purchase_amount: '매입 후 총 금액',
        price: '판매가',
        purchase_price: '판매가',
        purchase_price_taxable: '판매가 / 과세여부',
        purchase_price_change: '판매가 변경',
        bulk_purchase_price_change: '판매가 변경 대량 등록은 한 번에 최대 {{totalBulkPurchasePriceChange}}개 까지 가능합니다',
        purchase_price_change_warning:
            '판매가 변경 시 재고수불부 정산 등 데이터 오류에 영향을 미칠 수 있으니 꼭 필요한 경우에 한해서 다시 한번 확인 후 처리하시기 바랍니다',
        purchase_price_reservation: '판매가 변경 예약',
        purchase_price_reservation_details: '판매가 변경 예약 내역',
        no_purchase_price_reservation_details: '판매가 변경 예약 내역이 없습니다',
        bulk_purchase_price_reservation: '판매가 변경 예약 대량 등록',
        purchase_price_reservation_complete: '판매가 변경 예약이 완료되었습니다',
        purchase_price_registration: '판매가 예약 등록',
        bulk_purchase_price_change_file: '판매가 일괄 변경 예약 Excel 파일',
        bulk_purchase_price_edit: '판매가 일괄 수정',
        bulk_purchase_price_reservation_complete: '판매가 일괄 예약 등록이 완료 되었습니다',
        bulk_purchase_price_adjustment: '판매가 일괄 조정',
        purchase_price_input: '판매가 입력',
        purchase_price_required: '판매가는 필수입니다',
        purchase_price_can_not_minus: '판매가는 음수일 수 없습니다',
        purchase_cost: '매입원가',
        purchase_settlement_details: '매입정산내역이 존재하지 않습니다',
        empty_page_purchase_history: '매입 내역이 존재하지 않습니다',
        purchaser: '브랜드',
        purchaser_id: '브랜드 ID',
        purchaser_search: '브랜드 검색',
        purchaser_holiday_registration: '브랜드 공휴일 등록',
        purchaser_management: '브랜드 관리',
        purchaser_buyer: '발주처 / 구매담당자',
        purchaser_liability_amount: '발주처 귀책 금액',
        purchaser_liability_amount_currency: '발주처 귀책 금액 원',
        purchaser_liability_return: '발주처 귀책 의 경우 귀책금액으로 반품내역이 생성됩니다',
        purchaser_same_standard: '발주처 기준동일',
        purchaser_contact: '발주처 담당자',
        purchaser_contact_info: '발주처 담당자 정보',
        purchaser_contact_info_1: '발주처 담당자 1) 정보',
        purchaser_contact_info_2: '발주처 담당자 2) 정보',
        purchaser_deadline_adjustment: '발주처 마감시간 일괄 조정',
        no_purchaser_list: '발주처 목록이 존재하지 않습니다',
        purchaser_selection: '발주처 선택',
        purchaser_edit: '발주처 수정',
        purchaser_registration: '브랜드 등록',
        purchaser_incoming_schedule: '발주처 입고 예정서 일재고',
        purchaser_info: '발주처 정보',
        purchaser_holiday_registration_complete: '발주처 휴일 등록이 완료 되었습니다',
        purchaser_holiday_deletion_complete: '발주처 휴일삭제가 완료 되었습니다',
        purchaser_holiday_info: '발주처 휴일정보',
        purchaser_required: '발주처는 필수 입니다',
        purchaser_manager: '발주처담당자',
        search_select_purchaser: '브랜드를 검색 선택 해주세요',
        purchaser_visibility_toggle: '{{purchaserForExposureOrNo}}발주처를 정말 {{exposureOrNo}} 전환 하시겠습니까',
        //purchaser_name: '브랜드명',
        purchaser_name_required: '발주처명은 필수입니다',
        purchaser_name_duplicate: '발주처명이 중복되었습니다',
        no_items_registered_in_purchaser: '발주처에 등록된 상품이 없습니다',
        purchaser_direct_delivery: '발주처에서 각 업장으로 직배송',
        purchaser_info_overview: '발주처정보',
        invoice_bulk_down: '송장발번',
        invoice_re_print: '송장 재출력',
        invoice_print: '송장 출력',
        invoice_bulk_down_description: '동일한 규격으로 선택한 주문들의 송장을 발번합니다.',
        invoice_list_not_found: '출력 가능한 송장이 없습니다.',
        print_option: '출력 옵션',
        selected_order_print: '선택한 주문의 송장 일괄 출력',
        selected_invoice_number_print: '송장번호 선택하여 출력',
        invoice_down: '납품서 다운로드',
        ida_invoice_down: '이다 납품서 다운로드',
        other_invoice_down: '이다 외 납품서 다운로드',
        packing_start: '패킹 시작',
        packing_inspection: '패킹검수',
        individual_picking_code: '개별피킹 코드',
        purchaser_name: '발주처명',
        goods_barcode: '상품 바코드',
        goods_barcode_scan: '상품 바코드 스캔',
        packing_complete: '패킹 종료',
        next_box_packing: '다음 박스 패킹',
        box_packing: '박스 패킹',
        total_picking_code: '토탈피킹 코드',
        goods_barcode: '상품바코드',
        packed_quantity: '검수수량',
        input_quantity: '입수량',
        box_code: '박스 코드',
        packaging_box: '포장 박스',
        box_modification: '박스변경',
        box_barcode: '박스 바코드',
        enter_box_barcode: '박스 바코드를 입력해주세요',
        invoice_number: '송장 번호',
        status: '상태',
        expiry_date: '유통기한',
        area: '권역',
        areaNm: '권역',
        total_packed_quantity: '총 패킹수량',
        packing_status: '패킹상태',
        quantity_input: '수량 입력',
        box_size: '박스 규격',
        now_box_size: '현재 포장박스 규격',
        goods_name: '상품명',
        order_qty: '주문수량',
        inspection_quantity: '검수수량',
        packing_work_end: '패킹 작업 종료',
        packing_work_end_confirm_message_1: '페이지를 벗어날 경우',
        packing_work_end_confirm_message_2: '패킹완료 되지 않은 상품은 검수 초기화 됩니다.',
        packing_work_end_confirm_message_3: '박스에 입수되어 있는 상품을 꺼내주세요.',
        packing_incomplete_items: '아직 검수되지 않은 상품이 있습니다. 그래도 종료하시겠습니까?',
        packing_incomplete_items_for_invoice: '검수가 완료되지 않은 상품이 있습니다.',
        packing_inspection_reset: '패킹검수 초기화',
        packing_inspection_reset_confirm: '⚠️ 검수 내역이 모두 초기화됩니다.\n이 작업은 되돌릴 수 없습니다.\n계속 진행하시겠습니까?',
        packing_inspection_reset_success: '패킹검수가 성공적으로 초기화되었습니다.',
        individual_picking_code_required_for_reset: '초기화하려면 개별피킹코드를 먼저 입력해주세요.',
        inspection_completed: '검수 완료',
        already_inspected_product: '이미 검수완료된 상품입니다.',
        packing_exceeded: '패킹 초과',
        packing_quantity_exceeds_order_quantity: '패킹 수량이 주문 수량을 초과할 수 없습니다.',
        inspection_update_error: '검수 업데이트 중 오류가 발생했습니다.',
        barcode_error: '바코드 오류',
        product_not_found_for_barcode: '해당 바코드의 상품을 찾을 수 없습니다',
        packing_complete_auto: '패킹 완료',
        packing_complete_auto_message: '모든 상품이 검수완료되었습니다. 패킹완료 처리합니다.',
        packing_already_completed: '이미 완료된 패킹',
        packing_complete_confirm_info: '실제 박스 수량과 일치하는지 확인 후 확인을 눌러주세요.',
        packing_already_completed_message: '이미 송장번호와 박스번호가 발번된 패킹입니다. 초기화면으로 돌아갑니다.',
        cargo_outbound_no_invoice_print: '화물출고로 처리합니다. 송장이 출력되지 않습니다.',
        cargo_outbound: '화물출고',
        inspection_start: '검수 시작',
        cargo_complete_with_box_count: '패킹완료 및 박스수량 입력',
        batch_inspection_reinspection_not_allowed: '일괄검수완료 건은 패킹재검수를 할 수 없습니다',
        individual_picking_code_length_error: '개별피킹코드를 10자리 또는 14자리 입력해주세요',
        packing_inspection_data_fetch_failed: '패킹검수 데이터 조회 실패: {{error}}',
        no_items_available_for_assignment: '할당 가능한 상품이 없습니다',
        server_connection_error: '서버에 연결할 수 없습니다. 네트워크 상태를 확인해주세요.',
        next_box_packing_failed: '다음 박스 패킹 실패: {{error}}',
        packing_complete_failed: '패킹 완료 실패: {{error}}',
        quantity_must_be_at_least_one: '수량은 1 이상이어야 합니다',
        over_packing_not_allowed: '오버검수 불가능! 주문수량({{orderQty}}) - 현재검수수량({{currentPackedQty}}) = 남은검수가능수량({{remainingQty}})개입니다.',
        packing_inspection_reset_failed: '패킹검수 초기화 실패: {{error}}',
        box_reset: '박스 초기화',
        box_reset_confirm: 'Box {{boxSeq}}을(를) 초기화하시겠습니까?\n이 작업은 되돌릴 수 없습니다.',
        box_reset_success: '박스가 초기화되었습니다.',
        inspection_qty_edit: '검수 수량 수정',
        box_reset_select: '박스 초기화 - 박스 선택',
        inspection_qty_edit_select: '검수 수량 수정 - 박스 선택',
        no_box_found: '조회된 박스가 없습니다.',
        please_scan_picking_code: '개별피킹코드를 먼저 스캔해주세요.',
        inspection_qty_edit_success: '검수 수량이 수정되었습니다.',
        same_quantity_warning: '현재와 동일한 수량입니다.',
        max_modifiable_qty_warning: '최대 수정 가능 수량은 {{max}}개 입니다.',
        modify_quantity: '수정 수량',
        current_assigned_qty: '현재 할당수량',
        max_modifiable_qty: '최대 수정 가능 수량',
        packing_re_inspection: '패킹 재검수',
        packing_re_inspection_complete: '패킹 재검수 완료',
        re_inspection_incomplete_warning: '모든 수량이 박스에 할당되지 않았습니다. 할당 완료 후 종료해주세요.',
        box_barcode_required: '박스바코드를 스캔해주세요.',
        re_inspection_must_complete: '박스 수정 또는 수량 수정 이력이 있어 패킹 재검수 완료를 해야 합니다.',
        re_inspection_reprint_confirm: '패킹 재검수시 송장을 모두 재출력해서 새로 부착 해야합니다.',
        inquiry: '조회',
        scan_goods_barcode: '상품바코드를 스캔하세요',
        enter_inspection_quantity: '검수할 수량을 입력하세요',
        packing_status_not_started: '미시작',
        packing_status_complete: '완료',
        packing_status_in_progress: '진행중',
        inspection_status_not_inspected: '미검수',
        inspection_status_partial: '부분검수',
        inspection_status_complete: '검수완료',
        cancel: '취소',
        confirm: '확인',
        location_alias_modification_message: '로케이션 명칭을 수정하시겠습니까?',
        location_alias_modification_success_message: '로케이션 명칭이 수정이 완료되었습니다.',
        location_alias_modification_error_message: '로케이션 명칭 수정을 실패하였습니다.',
        outbound_pending: '출고대기',
        outbound_work: '출고작업',
        outbound_complete: '출고완료',
        outbound_complete_old: '출고완료_old',
        invoice_number: '송장번호',
        purchaser: '브랜드',
        logistics_number: '물류번호',
        goods_id: '상품ID',
        product_name: '상품명',
        order_quantity: '주문수량',
        loading_quantity: '배송수량',
        unit: '단위',
        outbound_date: '출고일',
        packing_complete: '패킹완료',
        start_date: '시작일',
        end_date: '종료일',
        inspection_status: '검수상태',
        partial_inspection: '부분검수',
        inspection_complete: '검수완료',
        box_cnt: '박스 수',
        total_qty: '합계수량',
        urgent_outbound: '긴급출고',
        urgent_outbound_type: '긴급출고 유형',
        type: '유형',
        cargo: '화물',
        parcel: '택배',
        delivery_status: '배송상태',
        delivery_in_progress: '배송중',
        delivery_completed: '배송완료',
        invoice_registration: '송장접수',
        packing_completion_date: '패킹완료일',
        packing_start_date: '패킹 시작일시',
        individual_picking_code: '개별피킹코드',
        product: '상품',
        scheduled_outbound_date: '출고예정일',
        one_or_more: '1개 이상',
        three_or_more: '3개 이상',
        five_or_more: '5개 이상',
        ten_or_more: '10개 이상',
        select_area: '권역',
        sales_reflection: '매출 반영',
        no_sales_report: '매출 신고 내역이 존재하지 않습니다',
        sales_report_pending: '매출 신고 대기 내역',
        sales_transfer: '매출 이관',
        sales_invoice: '매출 정산서',
        sales_invoice_updated: '매출 정산서 갱신이 완료 되었습니다',
        sales_invoice_resend_complete: '매출 정산서 메일 재전송이 완료 되었습니다',
        sales_invoice_deleted: '매출 정산서 삭제',
        sales_invoice_delete_complete: '매출 정산서 삭제가 완료 되었습니다',
        sales_invoice_confirm_all: '매출 정산서 일괄 확정',
        sales_invoice_finalize: '매출 정산서 확정',
        sales_invoice_finalize_complete: '매출 정산서 확정이 완료 되었습니다',
        sales_price_reservation: '매출가 일괄 변경 • 예약',
        sales_price_edit_excel_file: '매출가 일괄 수정 - Excel 파일',
        unit_sales_price_management: '매출단가 관리',
        unit_sales_price_reservation: '매출단가 변경 예약 등록은 한 번에 최대 {{maxUnitSalesPriceReservation}}개 까지 가능합니다',
        unit_sales_price_bulk_change: '매출단가 일괄 변경',
        unit_sales_price_bulk_complete: '매출단가 일괄 변경 등록이 완료되었습니다',
        unit_sales_price_query: '매출단가 조회',
        reflection_of_sales: '매출반영',
        sales_transfer_order_selection: '매출이관 대상 주문을 하나 이상 선택하세요',
        sales_transfer_irreversible: '매출이관 완료 시 원복은 불가하며, 수관 발주처 정산 내 반영 청구 되오니 다시 한 번 확인 후 처리하시기 바랍니다.',
        sales_profit_margin_1: '매출이익률',
        sales_settlement_details: '매출정산내역이 존재하지 않습니다',
        customer: '발주처',
        customer_id: '발주처 ID',
        customer_search: '발주처 검색',
        customer_management: '발주처 관리',
        customer_purchasing_agent: '발주처 구매처 작업자',
        customer_classification_brand: '발주처 구분 / 브랜드',
        customer_classification_type: '발주처 구분 / 업태 / 업종',
        customer_classification_required: '발주처 구분은 필수 입니다',
        customer_driver_contact: '발주처 기사연락처 기사명 배정 라우트',
        customer_contact: '발주처 담당자 연락처',
        customer_contact_name: '발주처 담당자 이름',
        customer_contact_email: '발주처 담당자 이메일',
        customer_contact_info: '발주처 담당자 정보',
        customer_contact_info_1: '발주처 담당자 1) 정보',
        customer_contact_info_2: '발주처 담당자 2) 정보',
        customer_bulk_registration_limit: '발주처 대량 등록은 한 번에 최대 {{customerBulkRegistrationLimit}}개 까지 가능합니다',
        customer_bulk_registration_complete: '발주처 대량 등록이 완료 되었습니다',
        customer_registration: '발주처 등록',
        customer_bulk_registration: '발주처 등록 - 대량',
        customer_route_management: '발주처 라우트 추가 / 삭제는 12시~19시 내에서만 가능합니다',
        customer_list_2: '발주처 리스트',
        customer_virtual_account: '발주처 발주처 가상계좌번호',
        customer_return_exchange_code: '발주처 발주처 반품 교환코드 상세 내용',
        customer_business_id: '발주처 발주처 사업자 번호',
        customer_representative: '발주처 발주처 사업자번호 대표자',
        customer_consultation_notes: '발주처 발주처 상담 내용',
        customer_details: '발주처 발주처 상세 내용',
        customer_address: '발주처 발주처 주소',
        customer_delivery_date: '발주처 배송일',
        customer_brand: '발주처 브랜드',
        customer_selection: '발주처 선택',
        customer_edit_registration: '발주처 수정 발주처 등록',
        customer_avg_monthly_order: '발주처 월 평균 총 주문금액',
        customer_info: '발주처 정보',
        customer_info_bulk_adjustment: '발주처 정보 일괄 조정',
        customer_info_excel_file: '발주처 정보 Excel 파일',
        customer_settlement: '발주처 정산',
        customer_total_refund: '발주처 총 환불 금액',
        customer_addition: '발주처 추가',
        customer_refund_amount: '발주처 환불 금액',
        customer_classification: '발주처구분',
        search_select_customer: '발주처를 검색/선택 해주세요',
        customer_selection_required: '발주처를 선택하여 주시기 바랍니다',
        customer_selection_prompt: '발주처를 선택해주세요',
        customer_add_prompt: '발주처를 추가 해주세요',
        customer_name: '발주처명',
        customer_name_entry_limit: '발주처명은 50자리 이하로 입력하여 주십시오',
        customer_name_required: '발주처명은 필수 입니다',
        customer_name_duplicate: '발주처명이 중복되었습니다',
        number_of_sales_outlets: '발주처수',
        customer_preorder_cancellation: '발주처에서 사전에 주문한 내역은 취소되지 않습니다',
        customer_order_handling: '발주처에서 상품 주문 시',
        customer_inbound_routing: '발주처의 출차 센터별 지정된 입고 센터로 상품이 입고 됩니다',
        menu_delete: '메뉴 삭제',
        menu_delete_success: '메뉴 삭제에 성공 하였습니다',
        menu_create_success: '메뉴 생성에 성공 하였습니다',
        memo: '메모',
        message_required: '메시지 내용은 필수입니다',
        message_input_prompt: '메시지 내용을 입력하세요',
        delete_success: '삭제에 성공 하였습니다',
        document: '문서',
        logistic_code: '물류코드',
        select_checkbox_list: '목록 체크 박스 선택',
        non_payment: '미납',
        non_payment_price: '미납 {{nonPaymentPrice}} 원',
        return_history: '반품 내역',
        return_type: '반품유형',
        return_code: '반품코드',
        return_quantity: '반품수량',
        return_reason: '반품사유',
        empty_page_return_history: '반품 내역이 존재하지 않습니다',
        report_return_quantity: '반환량',
        occurrence_date: '발생일',
        order_classification_lead_time: '발주 구분 / 리드타임',
        bulk_inspection_complete: '일괄검수완료',
        invoice_registration_status: '송장접수상태',
        not_registered: '미접수',
        partial_registration: '부분접수',
        registration_complete: '접수완료',
        purchase: {
            order: '발주',
            order_possible_days: '발주 가능 요일',
            order_holidays_registration: '발주 가능 요일 외 별도 공휴일을 등록합니다',
            order_classification: '발주 구분',
            order_classification_required: '발주 구분은 필수 입니다',
            order_amount: '발주 금액',
            order_details: '발주 내역',
            order_details_not_available: '발주 내역이 없습니다',
            order_unit: '발주 단위',
            order_request_sent_to_supplier: '발주 등록 시 해당 상품의 매입처로 발주 요청서 가 발송 됩니다',
            order_lead_time: '발주 리드타임',
            order_deadline_time: '발주 마감 시간',
            order_expired_warning: '발주 마감시간이 지난 상품이 포함되어 있습니다 발주 상품을 다시 확인해주시기 바랍니다',
            order_multiple_units: '발주 배수',
            order_products: '발주 상품',
            order_product_classification: '발주 상품 구분',
            order_inactive_product_warning: '발주 상품 중 미사용 중인 상품이 포함되어 있습니다 계속 발주를 진행 하시겠습니까',
            order_quantity_input: '발주 수량 입력',
            order_request_information: '발주 요청 정보',
            order_request_form_details: '발주 요청서 상세',
            order_request_form_edit: '발주 요청서 수정',
            order_request_form_edit_to_supplier: '발주 요청서 수정 시 해당 상품의 매입처로',
            order_request_form_updated: '발주 요청서가 수정 되었습니다',
            order_request_form_selection: '발주 요청서를 선택해 주세요',
            order_request_date: '발주 요청일',
            order_warehouse_receipt_settings: '발주/입고 설정',
            order_warehouse_receipt_check_required: '발주/입고 설정은 한개 이상 체크되어야 합니다',
            order_warehouse_receipt_time_required: '발주/입고 센터 설정 시, 상품 입고 센터/입고 예정시간은 필수 입니다',
            order_receipt_quantity: '발주 입고 시 입수량',
            order_receipt_information: '발주 입고 정보',
            order_information: '발주 정보',
            order_view_permission: '발주 조회 허용',
            order_cancellation_1: '발주 취소',
            order_cancellation_include_history: '발주 취소 내역 포함',
            order_notes: '발주 특이사항',
            order_available: '발주가능 상품구분',
            order_available_days_select: '발주가능 요일 선택',
            order_available_days_required: '발주가능 요일은 필수입니다',
            ordering_category: '발주구분',
            ordering_calendar: '발주달력',
            deadline_for_ordering_weekend_minutes_required: '발주마감(주말) -분은 필수 입니다',
            deadline_for_ordering_weekend_hours_required: '발주마감(주말) -시간은 필수 입니다',
            deadline_for_ordering_weekday_minutes_required: '발주마감(평일) -분은 필수 입니다',
            deadline_for_ordering_weekday_hours_required: '발주마감(평일) 시간은 필수 입니다',
            order_multiple: '발주배수',
            order_status: '발주상태',
            order_quantity: '발주수량',
            order_quantity_unit: '발주수량/단위',
            order_quantity_order_unit: '발주수량 / 발주단위',
            order_request: '발주요청',
            order_request_cancellation_available: '발주요청 상태만 발주 취소가 가능합니다',
            order_request_internal_states: '발주요청 상태코드 내부 발주요청 발주취소 입고대기 입고확인 입고완료 입고확정',
            order_request_form_search: '발주요청서 검색',
            order_request_form_select: '발주요청서 선택',
            order_request_form_code: '발주요청서 코드',
            order_request_date_select: '발주요청일 선택',
            order_date: '발주일',
            order_date_lead_time: '발주일{{purchaseLeadDay}}로부터 센터 입고까지 소요 기간',
            order_date_and_time: '발주일시',
            orderer: '발주자',
            orderer_search: '발주자 검색',
            orderer_select_prompt: '발주자 검색/선택 해주세요',
            orderer_information: '발주자 정보',
            order_cancellation_2: '발주취소',
            order_cancellation_confirmed: '발주취소가 완료 되었습니다',
            ordering_code: '수주번호',
            ordering_code_product: '발주코드 발주상품',
            order_request_date_time: '발주요청일시',
        },
        publication_date: '발행일',
        date_of_publication: '발행일자',
        banner_photo: '배너사진',
        delivery: '배송',
        delivery_area_selection: '배송 권역 선택',
        delivery_area_selection_required: '배송 권역은 필수입니다',
        delivery_driver_phone: '배송 기사 전화번호',
        delivery_person_in_charge: '배송 담당자',
        delivery_manager: '배송 매니저',
        delivery_cost: '배송 비용',
        delivery_photo: '배송 사진',
        delivery_no_photo: '배송 사진이 없습니다',
        delivery_entry_method_1: '배송 시 진입 방법',
        delivery_expected_date: '배송 예정일',
        delivery_completed: '배송 완료',
        delivery_no_completion_records: '배송 완료 내역이 없습니다',
        delivery_day_selection_1: '배송 요일 선택',
        delivery_day_adjustment: '배송 요일 조정',
        delivery_day_required: '배송 요일은 필수 입니다',
        delivery_information: '배송 정보',
        delivery_departure_info: '배송 출차지 정보',
        delivery_area_info: '배송 권역 정보',
        delivery_notes: '배송 특이사항',
        delivery_schedule_day: '배송 형태 / 배송 요일',
        delivery_type_selection: '배송 형태 선택',
        delivery_center_departure: '배송 형태 / 출차 센터',
        delivery_person_selection: '배송담당자 선택',
        delivery_manager_line_code: '배송매니저 간선코드',
        delivery_non_delivery_days: '배송불가 요일',
        non_delivery_days: '배송불가요일',
        delivery_photo_confirmation: '배송사진을 확인할 수 있습니다',
        delivery_status: '배송상태',
        delivery_quantity: '배송수량',
        delivery_excess_quantity: '배송수량 초과',
        expected_delivery_date: '배송예정일',
        delivery_complete: '배송완료',
        delivery_complete_unsettled_orders_only: '배송완료 및 매출정산 미반영 주문만 가능합니다',
        delivery_partial: '배송완료 부분배송',
        delivery_loaded: '배송완료 상차완료',
        delivery_issue_unprocessable: '배송완료와 정상 상태 건 이슈 처리 불가',
        delivery_completion_datetime: '배송완료일시',
        delivery_completed_date: '배송완료일',
        delivery_day: '배송요일',
        delivery_day_selection_2: '배송요일 선택',
        delivery_type: '배송유형',
        delivery_vehicle_number: '배송유형 / 차량번호',
        delivery_date: '배송일',
        delivery_date_return_policy: '배송일이 현재 월과 달라 반품 교환 접수가 불가합니다',
        shipper: '배송자',
        preparing_for_delivery: '배송준비중',
        in_delivery: '배송중',
        delivery_address_photo_upload: '배송지 사진 업로드',
        delivery_address_photo_attachment: '배송지 사진 첨부',
        delivery_address: '배송지 주소',
        delivery_address_direct_input: '배송지 주소 직접 입력',
        delivery_address_required: '배송지 주소는 필수 입니다',
        delivery_address_photo: '배송지 첨부 사진',
        shipping_address_road_name: '배송지기본주소(도로명)',
        shipping_address_jibun: '배송지기본주소(지번)',
        detailed_delivery_address: '배송지상세주소',
        shipping_address_zip_code: '배송지우편번호',
        delivery_address_same_check: '배송지주소동일여부',
        delivery_entry_method_2: '배송진입방법',
        special_delivery_information: '배송특이사항',
        delivery_form: '배송형태',
        delivery_form_required: '배송형태는 필수 입니다',
        number_of_deliveries: '배송횟수',
        drainage: '배수',
        drainage_order: '배수 발주',
        assignment: '배정',
        assignment_route: '배정 라우트',
        assignment_sales_location: '배정 발주처',
        assignment_datetime: '배정일시',
        assignment_date_selection: '배정일자 선택',
        assignor: '배정자',
        arrangement_success: '배치 실행 성공',
        arrangement_failure: '배치 실행 실패 했습니다',
        placement_confirmation: '배치를 실행 하시겠습니까?\n 기존 실행되는 시간대에 실행하지 않는 경우에는 문제가 발생 할 수 있습니다',
        placement_prompt: '배치를 실행하시겠습니까',
        button_document_add: '버튼을 클릭하여 문서 추가 (20MB 이하, 최대 10개)',
        button_photo_add: '버튼을 클릭하여 사진 추가 ({{lessCapacity}}이하 최대 {{maxFileCount}}개)',
        button_file_upload: '버튼을 클릭하여 파일을 업로드 하세요',
        button_event: '버튼이벤트',
        number_1: '번호',
        universal_product: '범용 상품',
        bay: '베이',
        bay_rack: '베이 / 렉',
        change: '변경',
        change_amount_input: '변경 금액 입력',
        change_purchase_price: '변경 판매가',
        change_reason: '변경 사유',
        change_reason_input: '변경 사유 입력',
        change_cancel_ignore: '변경 사항을 무시하고 취소 하시겠습니까',
        change_no_modifications: '변경 사항이 없습니다',
        change_not_applied: '변경 사항이 적용되지 않습니다 변경 사항을 무시하고 취소 하시겠습니까',
        change_not_effective: '변경 사항이 적용되지 않았습니다',
        change_reservation: '변경 예약',
        change_expected_purchase_margin: '변경 예정 구매 이익율',
        change_expected_date: '변경 예정일',
        change_history_purchase_price: '변경 이력 매입가',
        change_datetime: '변경 일시',
        change_effective_date_1: '변경 적용일',
        change_effective_date_limit: '변경 적용일은 [당일 +1] 로부터 최대 3개월까지 가능합니다',
        change_effective_date_required: '변경 적용일은 필수입니다',
        change_before: '변경 전',
        change_before_amount: '변경 전 금액',
        change_immediate_settlement: '변경 즉시 정산금액이 수정됩니다 계속 저장 하시겠습니까',
        change_departure_center_selection: '변경 출차 센터 선택',
        change_category: '변경 카테고리',
        change_sales_margin: '변경 판매 이익율',
        change_after: '변경 후',
        change_after_amount: '변경 후 금액',
        changed_no_records: '변경된 내역이 없습니다',
        changed_no_changes: '변경된 사항이 없습니다',
        changed_credit_limit_reset: '변경된 여신 한도 금액은 변경 전 금액까지 결제가 되면 자동 원복 됩니다',
        change_reservation_deleted: '변경예약 삭제가 완료 되었습니다',
        change_reservation_completed: '변경예약이 완료 되었습니다',
        change_completed: '변경이 완료 되었습니다',
        change_history: '변경이력',
        changer: '변경자',
        change_effective_date_2: '변경적용일',
        change_amount_variation: '변동 금액',
        change_rate: '변동율',
        conversion: '변환 수량',
        conversion_quantity: '변환수량',
        custody_inventory: '보관 재고',
        storage_inventory: '보관재고',
        storage_inventory_receiving_center: '(보관재고)입고센터',
        storage_inventory_auto_order_status: '(보관재고)자동발주여부',
        storage_inventory_no_auto_order: '보관재고는 자동발주를 선택할 수 없습니다',
        storage_inventory_quantity: '보관재고량',
        storage_order_cancel_possible: '보관재고만 발주 취소가 가능합니다',
        supplement_quantity: '보충 수량',
        supplement_order: '보충 지시',
        supplement_order_list: '보충 지시 리스트',
        supplementary_quantity: '보충수량',
        value_added_tax: '소비세',
        partially_not_received: '부분미입고',
        partial_delivery: '부분배송',
        partial_loading_unloading: '부분상차 미상차',
        partial_completion: '부분완료',
        inventory_slump: '부진 재고',
        inventory_date: '재고일자',
        no_sluggish_inventory: '부진재고가 없습니다',
        minute: '분',
        minute_input_limit: '00 ~ 59분 까지 입력해주세요',
        classification: '분류',
        location_distribution: '분배 로케이션',
        location_distribution_info: '분배 로케이션 정보',
        unnecessary: '불필요',
        brand: '거래처',
        brand_search: '거래처 검색',
        brand_contract_end: '거래처 계약종료 시 하위 발주처도 모두 계약종료 됩니다',
        brand_settlement: '거래처 정산',
        brand_management: '브랜드 관리',
        brand_exposure_products: '거래처 노출상품',
        brand_contact_info: '브랜드 담당자 1) 정보',
        brand_contact_info_2: '브랜드 담당자 2) 정보',
        brand_registration: '브랜드 등록',
        brand_revenue_percentage: '브랜드 매출액의',
        brand_business_number: '브랜드 브랜드 사업자번호 대표자',
        brand_selection: '브랜드 선택',
        brand_edit: '브랜드 수정',
        brand_information_1: '거래처 정보',
        brand_settlement_classification: '브랜드 정산 구분',
        brand_settlement_payment_date: '브랜드 정산 기준 / 결제일',
        brand_no_settlement_records: '브랜드 정산내역이 존재하지 않습니다',
        brand_statement_resent: '브랜드 정산서 메일 재전송이 완료 되었습니다',
        brand_statement_batch_confirm: '브랜드 정산서 일괄 확정',
        brand_statement_confirmed: '브랜드 정산서 확정이 완료 되었습니다',
        brand_ID_1: '브랜드 ID',
        brand_mandatory: '거래처는 필수 입니다',
        brand_manager: '브랜드담당자',
        brand_search_prompt: '거래처를 검색/선택 해주세요',
        brand_name: '거래처명',
        brand_name_length_limit: '거래처명은 50자리 이하로 입력하여 주십시오',
        brand_name_mandatory: '거래처명은 필수 입니다',
        brand_name_duplicate: '거래처명이 중복되었습니다',
        brand_ID_2: '거래처아이디',
        brand_information_2: '브랜드정보',
        note: '비고',
        note_requests: '비고 요청사항',
        password: '비밀번호',
        password_input: '비밀번호 입력',
        password_mismatch_1: '비밀번호가 일치하지 않습니다',
        password_match_1: '비밀번호가 일치합니다',
        password_registration_condition: '비밀번호가 일치해야 등록 가능합니다',
        password_enter_prompt: '비밀번호를 입력해주세요',
        expense: '비용',
        cost_input_prompt: '비용을 입력해주세요',
        non_member: '비회원',
        non_member_consultation_history: '비회원 상담이력만 보기',
        business_registration_address: '사업등록증 상 주소',
        business_registration_number_1: '사업자 등록번호',
        business_number_duplicate_1: '사업자 등록번호가 중복되었습니다',
        business_number_length: '사업자 등록번호는 13자리입니다',
        business_number_mandatory: '사업자 등록번호는 필수 입니다',
        business_registration_number_length: '사업자 등록자번호는 10자리입니다',
        business_registration_zip_code: '사업자 등록증상 우편번호',
        business_number: '사업자 번호',
        business_name_registration: '사업자 상호',
        business_name_number_registration: '사업자 상호 / 등록번호',
        business_name_length_limit: '사업자 상호는  30자리 이하로 입력하여 주십시오',
        business_name_mandatory: '사업자 상호는 필수 입니다',
        business_name_input_prompt: '사업자 상호를 입력해주세요',
        business_name_required: '사업자 상호명은 필수 입니다.',
        business_name_mandatory_full: '사업자 상호명은 30자리 이하로 입력하여 주십시오',
        business_name_duplicate_1: '사업자 상호명이 중복되었습니다',
        business_type_1: '사업자 유형',
        business_registration_number_2: '사업자등록번호',
        business_number_duplicate_2: '사업자등록번호가 중복되었습니다',
        business_registration_address_standard: '사업자등록증 상 주소',
        business_registration_address_same: '사업자등록증 상 주소 동일',
        business_registration_address_mandatory: '사업자등록증 상 주소는 필수 입니다',
        business_registration_road_name: '사업자등록증상도로명',
        business_registration_detailed_address: '사업자등록증상상세주소',
        business_registration_jibun: '사업자등록증상지번',
        business_number_input_limit: '사업자번호 10자리를 입력해주세요',
        business_number_mandatory_input: '사업자번호를 필수로 입력해주세요',
        business_name: '사업자상호',
        business_name_duplicate_2: '사업자상호가 중복되었습니다',
        business_name_label: '사업자상호명',
        business_type_2: '사업자유형',
        use: '사용',
        exceed_storage_rate: '사용 적치율 초과',
        use_conversion: '사용 전환',
        use_status: '사용여부',
        user_selection: '사용자 선택',
        username: '사용자명',
        user_information: '사용자정보',
        use_conversion_unuse: '사용전환 미사용 전환',
        in_use: '사용중',
        reason: '사유',
        reason_content: '사유 내용',
        reason_detail_input: '사유 상세 입력',
        reason_selection: '사유 선택',
        reason_input: '사유 입력',
        reason_input_confirmation: '사유 입력 확정 처리',
        reason_mandatory: '사유는 필수 입니다',
        reason_selection_prompt: '사유를 선택하세요',
        enter_reason: '사유입력',
        excel_file: 'EXCEL 파일',
        picture: '사진',
        picture_upload: '사진 업로드',
        delete: '삭제',
        deleted: '삭제 되었습니다',
        delete_complete: '삭제 완료',
        delete_completed: '삭제가 완료되었습니다',
        delete_status: '삭제여부',
        mountainous_district: '산지',
        acknowledged_above_content: '상기 내용을 확인했습니다',
        top_summary: '상단 요약',
        counsel_category: '상담 구분',
        counsel_details: '상담 내역',
        no_counsel_details: '상담 내역이 없습니다',
        counsel_content: '상담 내용',
        counsel_content_required: '상담 내용은 필수입니다',
        counsel_registration: '상담 등록',
        counsel_detail: '상담 상세',
        counsel_status_change_completed: '상담 상태 변경이 완료 되었습니다',
        counsel_type: '상담 유형',
        counsel_type_detail_required: '상담 유형 상세는 필수입니다',
        counsel_type_required: '상담 유형은 필수입니다',
        counsel_datetime: '상담 일시',
        counsel_processing_datetime: '상담(처리) 일시',
        counsel_processing_date: '상담(처리) 일자',
        consultation_category: '상담구분',
        consultation_details: '상담내용',
        consultation_details_enter: '상담내용을 입력하세요',
        consultation_type: '상담유형',
        consultation_type_selection: '상담유형을 선택하세요',
        consultation_date: '상담일',
        consultation_datetime: '상담일시',
        consultation_status_datetime: '상담일시 / 상태',
        counselor: '상담자',
        counselor_selection: '상담자 선택',
        particular: '상세',
        particular_details: '상세 내역',
        particular_content: '상세 내용',
        particular_content_required: '상세 내용은 필수입니다',
        particular_content_enter: '상세 내용을 입력해주세요',
        particular_reason_enter: '상세 사유를 입력해주세요',
        particular_edit: '상세 수정',
        particular_address: '상세 주소',
        detailed_reason: '상세사유',
        detailed_type: '상세유형',
        detailed_type_selection: '상세유형을 선택하세요',
        details_information: '상세정보',
        detailed_address_required: '상세주소는 필수 입니다',
        loading_inspection: '상차 검수중',
        loading_waiting: '상차 대기',
        loading_in_progress: '상차 대기중',
        no_loading_jobs: '상차 대기중인 작업이 없습니다',
        loading_ready: '상차 준비 완료 & 입차 지시',
        loading_inspection_datetime: '상차검수일시',
        situation: '상태',
        situation_change: '상태 변경',
        situation_change_completed: '상태 변경이 완료 되었습니다',
        situation_selection: '상태 선택',
        register_in_state: '상태로 등록',
        goods: '상품',
        goods_id: '상품 ID',
        goods_individual_registration: '상품 개별 등록',
        goods_search_popup: '상품 검색 팝업',
        goods_management: '상품 관리',
        lot_management: 'LOT 관리',
        package_management: '패키지 관리',
        package_registration: '패키지 등록',
        update_package: '패키지 수정',
        package: '패키지',
        goods_search: '상품 조회',
        package_component_goods_list: '구성상품리스트',
        package_component_goods_required: '패키지 구성상품은 필수입니다',
        composition_code: '구성코드',
        composition_code_select: '구성코드 선택',
        config_code_outbound_instruction: '구성코드 출고 지시',
        confirm_config_code_shipment: '{{count}}건의 주문을 출고 지시합니다.',
        bulk_inspection_single_outbcnt_only: '일괄 검수는 하나의 출고회차만 가능합니다.',
        bulk_inspection_by_outbcnt_confirm: '출고회차 {{outbCnt}} 전체를 일괄 검수합니다.',
        bulk_inspection_search_outbcnt: '출고회차를 검색하거나 항목을 선택해주세요.',
        bulk_inspection_with_invoice_confirm: '송장 일괄 출력도 같이 하시겠습니까?',
        normal_inspection_outbound_complete: '일반검수 출고완료',
        batch_inspection_outbound_complete: '일괄검수 출고완료',
        existing_outbound_complete: '기존 출고완료',
        outbound_complete_irreversible_warning: '출고완료 처리는 되돌릴 수 없습니다.',
        outbound_complete_target_count: '대상 주문: {{count}}건',
        outbound_complete_confirm: '{{count}}건의 주문을 출고완료 처리합니다. 되돌릴 수 없습니다.',
        select_outbound_round: '출고회차를 선택해주세요',
        no_outbound_complete_target: '출고완료 가능한 대상이 없습니다.',
        partial_inspection_warning: '부분검수 {{partialCount}}건 / 미검수 {{notInspectedCount}}건이 포함되어 있습니다. 검수 완료된 {{completedCount}}건만 출고완료 처리됩니다.',
        not_allowed_order_code: '선택한 주문에 포함되지 않는 피킹코드입니다.',
        please_select_order: '주문을 선택해주세요.',
        package_type: '패키지 타입',
        package_type_required: '패키지타입 선택은 필수입니다',
        package_id: '패키지ID',
        package_code: '패키지코드',
        package_name: '패키지명',
        package_name_required: '패키지명은 필수입니다',
        no_registered_packages: '등록된 패키지가 없습니다.',
        goods_regulation_management: '상품 규제 관리',
        goods_regulation_registration_completed: '상품 규제 등록이 완료 되었습니다',
        goods_period_regulation_bulk_registration: '상품 기간 규제 대량 등록',
        goods_period_regulation_registration: '상품 기간 규제 등록',
        goods_date_excel: '상품 날짜 구분 엑셀',
        contact_goods_manager: '상품 담당자에게 문의해주세요',
        goods_bulk_registration: '상품 대량 등록',
        goods_bulk_registration_limit: '상품 대량 등록은 한 번에 최대 {{totalGoodsBulkRegistration}}개 까지 가능합니다',
        goods_bulk_registration_completed: '상품 대량 등록이 완료 되었습니다',
        lot_bulk_registration: 'LOT 대량 등록',
        lot_bulk_registration_limit: 'LOT 대량 등록은 한 번에 최대 {{totalGoodsBulkRegistration}}개 까지 가능합니다',
        inbound_expected_bulk_registration_completed: '입고예정서 일괄 등록이 완료 되었습니다.',
        goods_bulk_edit: '상품 대량 수정',
        goods_bulk_expected_inbound: '입고예정서 일괄 등록',
        goods_second_image: '상품 두번째 이미지',
        goods_bulk_register: '상품 등록 - 대량',
        goods_inbound_expected_bulk_register: '입고예정서 일괄 등록',
        goods_list_deletion_restriction: '상품 목록이 있을 경우 삭제 할 수 없습니다',
        no_goods_list: '상품 목록이 존재하지 않습니다',
        goods_order_notes: '상품 및 발주 특이사항',
        goods_order: '상품 발주',
        goods_order_completed: '상품 발주가 완료 되었습니다',
        goods_inbound_plan_completed: '입고 예정서 등록이 완료 되었습니다',
        goods_photo: '상품 사진',
        goods_photo_registration: '상품 사진 등록',
        goods_photo_upload: '상품 사진 업로드',
        goods_photo_notes: '상품 사진・특이사항',
        goods_status: '상품 상태',
        goods_status_change_completed: '상품 상태 변경이 완료되었습니다',
        goods_status_batch_change: '상품 상태 일괄 변경',
        goods_lot_delete_change: '상품 LOT 일괄 삭제 ',
        goods_status_change_restriction: '상품 상태를 사용 으로 바꿀 수 없는 상품이 존재합니다',
        goods_product: '상품',
        goods_name: '상품명',
        goods_product_name_supplier: '상품 상품명 매입처 매입처',
        goods_selection: '상품 선택',
        goods_selection_then_input: '상품 선택 후 입력',
        goods_count: '상품 수',
        goods_edit_register: '상품 수정 상품 등록',
        goods_start_end_date: '상품 시작일 종료일',
        goods_type_brand: '상품 유형 / 브랜드',
        goods_type_required: '상품 유형은 필수 입니다',
        sku_code_required: 'SKU 코드는 필수 입니다',
        goods_batch_edit: '상품 일괄 수정',
        goods_batch_info_change_completed: '상품 일괄정보 변경이 완료 되었습니다',
        goods_receiving: '상품 입고',
        goods_receiving_center: '상품 입고 센터',
        goods_exposure_settings: '상품 전체 노출 설정',
        goods_info_file: '상품 정보 EXCEL 파일',
        lot_info_file: 'LOT 정보 EXCEL 파일',
        goods_order_unit: '상품 주문 단위',
        goods_order_unit_specification: '상품 주문 단위 / 규격',
        goods_order_unit_required: '상품 주문 단위는 필수 입니다',
        goods_order_unit_conversion_quantity_input: '상품 주문 단위에 따른 {{quantityAccordingToUnit}} 변환 수량 입력',
        goods_order_unit_spec: '상품 주문단위 규격',
        goods_first_image: '상품 첫번째 이미지',
        goods_additional_edit: '상품 추가/수정',
        goods_category: '상품 카테고리',
        goods_category_change: '상품 카테고리 변경',
        goods_category_sales_margin_change_record: '상품 카테고리별 판매 이익율 변경 내역',
        goods_category_sales_margin_setting: '상품 카테고리별 판매 이익율 설정',
        goods_category_sales_margin_set: '상품 카테고리별 판매 이익율을 설정 합니다',
        goods_item_code_product_name: '상품 타품목코드 상품명',
        goods_particulars: '상품 특이사항',
        goods_temperature_1: '상품 품온',
        goods_temperature_2: '품온',
        goods_temperature_origin: '상품 품온 / 원산지',
        goods_temperature_required: '상품 품온은 필수 입니다',
        product_specifications: '상품규격',
        product_name: '상품명',
        product_name_input: '상품명 입력',
        product_name_length_limit: '상품명은 {{productNameLengthLimit}}자 이내로 작성하여 주십시오',
        product_name_required: '상품명은 필수 입니다',
        product_number: '상품번호',
        product_adjustment_by_item_reason: '상품별 조정 금액 조정 사유',
        product_adjustment_case: '상품별 조정금액인 경우',
        product_order_details: '상품별 주문내역',
        product_order_details_excel_download: '상품별 주문내역 엑셀 다운로드',
        product_status: '상품상태',
        product_selection: '상품선택',
        lot_bulk_register: 'LOT 등록 - 대량',
        number_of_products: '상품수 개',
        product_id: '상품아이디',
        product_id_details: '상품아이디 상품명 매입가 권장판매가설정구분 구매이익율 고정가 권장판매가 변경적용일',
        total_sku_count: '총SKU수',
        total_quantity: '전체수량',
        missing_outb_id_error: '출고ID(outbId)가 없는 상품이 있습니다. 데이터를 다시 조회해주세요.',
        product_type: '상품유형',
        product_exposure_switch_prompt: '상품을 정말 미노출 노출 전환 하시겠습니까',
        product_exposure_priority: '상품의 판매가 매출가 는 아래의 우선순위에 따라 자동으로 노출 됩니다',
        setting_overall_product_exposure: '상품전체노출설정',
        product_information: '상품정보',
        product_order_unit: '상품주문단위',
        product_category_code: '상품카테고리코드',
        product_code: '상품코드',
        mutual: '상호',
        repayment: '상환',
        refresh: '새로고침',
        sprout: '새싹',
        sprout_customer_emergency_shipment_only: '새싹 고객 긴급출고 이력만 보기',
        sprout_customer_return_exchange_only: '새싹 고객 반품 & 교환 이력만 보기',
        sprout_customer_consultation_history_only: '새싹 고객 상담이력만 보기',
        sprout_customers_only: '새싹 고객만 보기',
        sprout_customer_claims_only: '새싹고객 클레임만 보기',
        omission: '생략',
        generation: '생성',
        creation_completed: '생성이 완료 되었습니다',
        creation_date: '생성일',
        constructor: '생성자',
        document_upload: '서류 업로드',
        server_error: '서버 에러',
        inbound_expected_bulk_registration_limit: '입고예정서 일괄 등록은 한 번에 최대 {{cnt}}개 까지 가능합니다.',
        invalid_data_from_server: '서버에서 유효하지 않은 데이터를 받았습니다',
        seo_hwaseong: '서화성',
        pre_order_inventory_deduction_period: '선주문 재고차감 기간',
        pre_order_print: '선주문 출력',
        pre_order_inventory_deduction_period_setting: '선주문재고차감기간',
        elected_high_school: '선출고',
        warning_invalid_early_shipment_day_goods: '[물류코드: {{logisticCodeForEarlyShipment}}] - 일재고 상품은 선출고 할 수 없습니다',
        elected_high_school_work_order: '선출고 작업지시',
        elected_high_school_instruction_completed: '선출고 지시 완료 되었습니다',
        elected_high_school_irreversible_warning: '선출고 지시 후에는 되돌릴 수 없으며 금일 출고작업 단계로 넘어갑니다',
        notice_of_election: '선출고지시',
        select: '선택',
        select_details: '선택 내역',
        not_selected_orders: '선택되지 않은 주문',
        not_selected_order_check: '선택되지 않은 주문이 있습니다 다시 확인 해주세요',
        no_selected_details: '선택된 내역이 없습니다',
        selected_products_regulation_end: '선택된 상품들이 즉시 규제 종료 처리 됩니다',
        selected_departure_center_no_supplier: '선택된 출차지센터에 연결된 매입처가 없습니다',
        selected_departure_center_no_products: '선택된 출차지센터에 연결된 상품이 없습니다',
        selected_product_exposure_switch_prompt: '선택하신 {{totalGoodsExposureOrNo}}개 상품을 정말 {{exposureOrNo}} 전환 하시겠습니까?',
        selected_product_exposure_switch_prompt_1: '선택하신 {{totalGoodsExposureOrNo}} 상품을 정말 {{exposureOrNo}} 전환 하시겠습니까?',
        selected_total_goods_for_early_shipment:
            '선택하신 {{totalGoodsForEarlyShipment}} 개의 상품을 선출고 지시 하시겠습니까? 선출고 지시 후에는 되돌릴 수 없으며, 금일 출고작업 단계로 넘어갑니다',
        selected_product_label_print: '선택하신 개의 상품에 대해 라벨 을 출력 하시겠습니까',
        selected_product_label_printing: '선택하신 {{totalGoodsForPrintingLabel}}개의 상품에 대해 라벨 을 출력하시겠습니까',
        selected_product_total_quantity_picking: '선택하신 {{totalGoods}}개의 상품에 대해 총량 피킹지 를 출력 하시겠습니까',
        selected_location_label_reprint: '선택하신 라벨 을 재출력하시겠습니까?',
        selected_label_reprint: '이미 출력된 라벨입니다. 해당 상품의 라벨을 재출력하시겠습니까?',
        selected_supplier_exposure_switch_prompt: '선택하신 {{totalPurchaserExposureOrNo}}개 매입처를 정말 {{exposureOrNo}} 전환 하시겠습니까?',
        selected_order_handling_warning:
            '선택하신 발주 내역이 입하 처리 되고 입고 확인서가 발행되며 이후에는 수정이 불가합니다 그래도 정말 강제 입고를 등록 하시겠습니까',
        selected_purchase_price_change_date: '선택하신 일자에 매입가 권장 판매가가 자동으로 변경됩니다',
        selected_statement_update: '선택하신 정산서를 갱신합니다 진행하시겠습니까',
        selected_statement_delete: '선택하신 정산서를 삭제합니다',
        selected_statement_batch_confirm: '선택하신 정산서를 일괄 확정 처리 합니다',
        selected_statement_confirm: '선택하신 정산서를 확정 처리 합니다',
        selected_order_all_delivery_complete: '선택하신 주문 건이 모두 배송완료 처리 되고 원복이 불가 합니다',
        selected_notice_password_entry: '선택한 {{totalSelectedNotice}}건의 공지사항 노출을 종료하려면 비밀번호를 입력하세요',
        setting_save: '설정 저장',
        success: '성공',
        success_forced_entry_complete: '강제 입하처리가 완료 되었습니다',
        sector: '섹터',
        sector_select_prompt: '섹터를 선택해주세요',
        center: '센터',
        center_selection: '센터 선택',
        center_lead_time: '센터 입고 리드타임',
        center_registration_required: '센터 입고설정 등록이 필요 합니다',
        center_information: '센터 정보',
        center_info_retrieval: '센터 정보 가져오기',
        center_add_prompt: '센터를 추가 해주세요',
        center_name: '센터명',
        center_specific_conditions: '센터별 세부 출고 조건을 설정해주세요',
        center_new_product_storage_conditions: '센터의 신규상품(보관재고) 세부 입고 조건을 설정해주세요. \n 시간당 입고량은 짝수로 입력해주세요',
        subcategory: '소분류',
        subcategory_addition_requirement: '소분류 카테고리 추가시 대 중분류는 필수입니다',
        subcategory_required: '소분류 카테고리는 필수입니다',
        subcategories_required: '소분류는 필수 입니다',
        consumption_period: '유통 기한',
        consumption_period_select: '유통 기한을 선택해 주세요',
        lot_no_select: 'LOT 번호를 선택해 주세요',
        expiration_date: '유통기한',
        expiration_date_option: '유통기한 기재 여부',
        expiration_date_deadline: '유통기한 마지노선',
        expiration_date_deadline_preorder: '유통기한 마지노선 선주문 재고차감',
        expiration_date_adjustment_preorder_inventory:
            '유통기한 마지노선 변경 시 재고 로스가 발생할 수 있으니 설정한 기간에 따라 선주문 상품의 가용재고가 차감 됩니다',
        expiration_date_deadline_preorder_period: '유통기한 마지노선 선주문 재고차감 기간',
        expiration_date_input_required: '유통기한 입력 - 선택된 발주 요청서가 없습니다',
        expiration_date_remaining_days: '유통기한 잔여일',
        expiration_date_remaining_days_query: '유통기한 잔여일 조회',
        expiration_date_adjustment: '유통기한 조정',
        expiration_date_addition: '유통기한 추가',
        expiration_date_indicated: '유통기한기재여부',
        consumption_period_limit: '유통기한마지노선',
        expiration_date_specific_inventory: '유통기한별 재고 상세',
        time_taken: '소요시간',
        loss_recovery: '손망실 복구',
        loss_processing: '손망실 처리',
        loss_amount: '손실금액',
        number_2: '수',
        water_channel_select_required: '수관 발주처 선택은 필수 입니다',
        manual_order: '수기 발주',
        manual: '수동',
        quantity: '수량',
        quantity_unit_specification: '수량 / 단위 / 규격',
        quantity_input: '수량 입력',
        quantity_required: '수량은 필수 입니다',
        enter_quantity: '수량입력',
        recipient_or_storage_location_input: '수령자 또는 보관 위치 입력',
        reception_contact: '수신 연락처',
        recipient: '수신자',
        recipient_number: '수신자 번호',
        recipient_selection: '수신자 선택',
        recipient_max_limit: '수신자는 최대 {{recipientMaxCount}}명까지 가능합니다',
        recipient_required: '수신자는 필수입니다',
        recipient_name: '수신자명',
        import_country_code: '수입국가코드',
        import_declaration_number: '수입신고번호',
        modification: '수정',
        modification_completed: '수정 되었습니다',
        modification_registration: '수정 등록',
        modification_history: '수정 이력',
        modification_addition: '수정 추가',
        modification_history_absent: '수정이력이 없습니다',
        modification_datetime: '수정일시',
        modifier: '수정자',
        edit_setting: '수정정보를 위한 세팅',
        edit_item: '수정항목',
        turn_order: '순번',
        enter_number: '숫자',
        enter_number_prompt: '숫자로 입력하여 주십시오',
        numbers_only_prompt: '숫자만 입력하세요',
        enter_numbers_prompt: '숫자입력',
        city: '시',
        enter_city_prompt: '00 ~ 23시 까지 입력해주세요',
        hourly_intake_even: '시간당 입고량은 짝수이어야 합니다',
        hourly_intake_required: '시간당 입고량은 필수입니다',
        system_default_setting: '시스템 기본 설정 : D + {{shlfDay}} 일',
        start_time_future_constraint: '시작시간은 종료시간의 미래시간을 선택할 수 없습니다',
        start_date: '시작일',
        start_date_required: '시작일은 필수 입니다',
        report_date: '신고일',
        new_registration: '신규 등록',
        reenter_new_password: '신규 비밀번호를 재 입력 해주세요',
        new_password: '신규 패스워드',
        enter_new_password: '신규 패스워드를 입력해주세요',
        application_datetime: '신청일시',
        application_date: '신청일자',
        actual_stock: '실 재고',
        actual_stock_quantity: '실 재고 수량',
        actual_delivery: '실배송 수량',
        actual_delivery_quantity: '실배송수량',
        real_picture_expiration: '실사 유통기한',
        real_picture_quantity: '실사 수량',
        room_temperature: '실온',
        actual_inventory: '실재고',
        actual_inventory_quantity: '실재고 수량',
        actual_order_process: '실제 발주는 상품의 판매 단위로 진행됩니다',
        actual_received_quantity: '실제입고수량',
        failure: '실패',
        execution: '실행',
        print_all_labels_under_condition: '아래 조건의 주문 라벨을 모두 출력합니다',
        release_all_orders_under_condition: '아래 조건의 주문이 모두 출고 지시 됩니다',
        print_all_bulk_picking_under_condition: '아래 조건의 총량 피킹지를 모두 출력합니다',
        guide: '안내',
        anpyeong: '안평',
        nighttime: '야간',
        food_download_form: '양식 다운로드',
        yesterday: '어제',
        upload_success: '업로드 성공',
        industry_is_required: '업종은 필수 입니다',
        industry_code: '업종코드',
        company_name: '업체명',
        company_type: '업체유형',
        company_code: '업체코드',
        business_status: '업태 / 업종',
        business_type_is_required: '업태는 필수 입니다',
        business_status_code: '업태코드',
        not_exist: '없음',
        error: '에러',
        error_retrieving_virtual_account_list: '에러 가상 계좌 목록을 가져오는 중 문제가 발생했습니다',
        error_occurred: '에러 발생',
        error_invalid_data_from_server: '에러 서버에서 유효하지 않은 데이터를 받았습니다',
        excel_download_image: '엑셀 다운로드 이미지',
        excel_file_download_request: '엑셀 파일 다운로드는 개발자에게 요청해주세요',
        excel_only: '엑셀만 가능',
        tsv_only: 'TSV만 가능',
        goddess_credit_status: '여신(채권) 상태',
        goddess_limit_adjustment_warning: '여신 한도 조정 시 손실 회수 가능성이 발생 할 수 있으니 주의 하시기 바랍니다',
        goddess_credit_limit: '여신 한도금액',
        goddess_insufficient_credit: '여신이 부족한 발주처나 재고가 부족한 상품이 포함되어 있습니다 다시 확인 후 업로드 해주시기 바랍니다',
        credit_limit: '여신한도',
        credit_limit_amount_required: '여신한도 금액은 필수입니다',
        credit_limit_in_currency: '여신한도 원',
        connected_sales_source: '연결 발주처',
        consolidated_sales_source: '연결발주처',
        related_code: '연관코드',
        related_code_length_limit: '연관코드는 자를 넘을 수 없습니다',
        contact: '연락처',
        contact_information_required: '연락처는 필수입니다',
        enter_required_contact_information: '연락처를 필수로 입력해주세요',
        heat: '열 단',
        heat_column: '열 열',
        key: '열쇠/카드키',
        sales_representative_corporate: '영업 담당자 / 거래법인',
        sales_manager: '영업담당자',
        sales_manager_corporate: '영업담당자 / 거래법인',
        sales_manager_search: '영업담당자 검색',
        sales_manager_selection_required: '영업담당자 선택은 필수 입니다',
        sales_manager_info: '영업담당자 정보',
        sales_manager_not_found: '영업담당자가 존재하지 않습니다',
        select_sales_manager: '영업담당자를 검색 선택 해주세요',
        depositor: '예금주',
        depositor_required: '예금주는 필수 입니다',
        estimated_depletion_days: '예상 소진 일수',
        reservation: '예약',
        reservation_details: '예약 내역',
        reservation_datetime: '예약일시',
        reservation_person: '예약자',
        reservation_pending: '예약중',
        reservation_confirmation: '예약확인',
        scheduled_product_info: '예정서 상품 정보',
        scheduled_info: '예정서 정보',
        today: '오늘',
        account_requirement: 'CMS ID는 필수 입니다',
        error_handling: '오류 처리',
        temperature: '온도',
        options: '옵션',
        complete: '완료',
        completion_time: '완료시간',
        except: '외 {{totalExceptBasic}}개',
        except_2: '외 {{totalExceptBasic2}}건',
        except_supplier: '외 {{totalExceptPurchaser}}개 브랜드',
        except_sales_source: '외 {{totalExceptSales}}개 발주처',
        except_product: '외 {{totalExceptProduct}}개 상품',
        except_product_lot: '외 {{totalExceptProductLot}}개',
        rate: '요율',
        daily_landing_count: '요일별 착지수',
        request: '요청 사항',
        request_quantity: '요청 수량',
        execute_request: '요청 실행',
        cancel_request: '요청 취소',
        quantity_available_for_request: '요청가능수량',
        number_of_requests: '요청건수',
        reason_for_request: '요청사유',
        select_reason_for_request: '요청사유 선택',
        additional_request_details: '요청사항',
        requested_quantity: '요청수량',
        request_date: '요청일',
        request_datetime: '요청일시',
        requester: '요청자',
        search_requester: '요청자 검색',
        requester_info: '요청자 정보',
        select_requester: '요청자를 검색 선택 해주세요',
        purpose: '용도',
        purpose_selection: '용도 선택',
        zip_code: '우편번호',
        zipcode_search: '우편번호 검색',
        zipcode_search_placeholder: '우편번호 입력 (예: 3591123)',
        zipcode_no_result: '검색 결과가 없습니다',
        collect_failure_list: '수집 실패',

        collect_failure_step: '단계',
        collect_failure_reason: '사유',
        collect_failure_resolved: '해소',
        collect_failure_show_resolved: '해소된 건도 보기',
        collect_failure_empty: '수집 실패 건이 없습니다',
        collect_failure_guide: '수집하다 못 받은 주문입니다. 상품을 등록한 뒤 다시 수집하면 들어오고, 그때 해소로 닫힙니다.',
        external_order_no: '채널 주문번호',
        collected_at: '수집일시',
        store_id: '스토어',
        tsv_upload: 'TSV 업로드',
        tiktok_order_receive: '틱톡 주문 접수',
        tiktok_order_receive_empty: '수집할 스토어 설정이 없습니다. channel-proxy.tiktok.stores 를 확인해주세요.',
        outbound_request: '출고요청',
        outbound_request_confirm: '선택한 주문을 출고요청합니다. 재고가 확보되고 출하관리로 넘어갑니다. 상품이 하나라도 모자라면 그 주문은 남습니다.',
        tiktok_order_receive_confirm: '틱톡의 발송대기 주문을 접수합니다. 이미 받아둔 주문은 건너뜁니다.',
        addr_lv1: '도도부현',
        addr_lv2: '시구정촌',
        addr_area: '정역',
        operable_days_absent: '운영가능한 요일이 없습니다',
        currency_unit: '엔',
        total_order_count: '총 주문수',
        total_box_count: '총 박스수',
        total_box_count_question: '총 박스 수',
        enter_total_box_count: '총 박스수를 입력하세요',
        total_box_count_required: '총 박스수를 먼저 입력해주세요',
        count_unit: '개',
        issue_processing: '이슈 처리',
        outbound_completed: '출고 완료',
        pending_outbound: '미출',
        not_inspected: '미검수',
        origin: '원산지',
        origin_other_mandatory: '원산지 기타 사항 필수입니다',
        origin_other_input: '원산지 기타 입력',
        origin_required: '원산지는 필수 입니다',
        month: '월',
        month_retrieve: '월 조회',
        month_week: '월 주',
        month_sales_volume: '월 판매량',
        month_average_order_amount: '월 평균 주문 금액',
        month_average_order_frequency: '월 평균 주문 횟수',
        month_disposal_rate: '월 폐기율',
        month_meeting: '월 회',
        distribution_identification_number: '유통식별번호',
        distribution_history_report: '유통이력신고 정보',
        type: '유형',
        type_selection: '유형 선택',
        invalid_response_handling: '유효하지 않은 응답 처리',
        bank: '은행',
        bank_virtual_account_error: '은행 가상계좌번호 에러',
        bank_selection_required: '은행 선택은 필수 입니다',
        search_results_by: '의 검색결과입니다',
        record_quantity: '이력 수량',
        record_report_number: '이력 신고 번호',
        record_report_number_alternative: '이력 신고번호',
        history_classification: '이력구분',
        name: '이름',
        enter_name_prompt: '이름을 입력해주세요',
        email: '이메일',
        email_format_error: '이메일 형식이 올바르지 않습니다',
        already_statement_generated: '이미 정산서 생성이 완료된 내역은 중복 생성이 불가합니다 확인 후 다시 선택해 주시기 바랍니다',
        already_settled_statement_included: '이미 정산이 확정된 정산서가 포함되어 있습니다 다시 선택해주시기 바랍니다',
        already_settled_statement_deletion: '이미 정산이 확정된 정산서는 삭제할 수 없습니다 다시 선택해주시기 바랍니다',
        already_reserved_sale_change: '이미 판매가 예약이 되어 있는 상품의 경우 최종 업로드 기준으로 변경됩니다',
        already_picked: '이미 피킹 되었습니다',
        image_download: '이미지 다운로드',
        image_download_repeat: '이미지 다운로드',
        this_month: '이번달',
        this_week: '이번주',
        enter_amount_above: '이상 입력해주세요.',
        enter_quantity_above: '수량을 입력해주세요.',
        issue: '이슈',
        issue_details: '이슈 내역',
        issue_details_view_only: '이슈 내역만 보기',
        no_issues_found: '이슈 내역이 없습니다',
        issue_handling: '이슈 처리',
        issue_handling_details: '이슈 처리 상세',
        issue_quantity: '이슈수량',
        issue_date: '이슈일',
        issue_handling_no_logistics_code: '이슈처리 - 선택된 물류코드가 없습니다',
        issue_handling_no_incoming_logistics_code: '이슈처리 - 선택된 입고 물류코드가 없습니다',
        issue_handling_no_outgoing_logistics_code: '이슈처리 - 선택된 출고 물류코드가 없습니다',
        issue_handling_no_logistics_code_found: '이슈처리 - 조회된 물류코드 정보가 없습니다',
        issue_handling_datetime: '이슈처리일시',
        utilization: '이용',
        utilization_stop_with_password_prompt: '이용 중지 처리를 하시는 경우 비밀번호를 입력해주세요',
        utilization_processing: '이용 처리 하시겠습니까',
        utilization_completed: '처리가 완료 되었습니다',
        stop_using: '이용중지',
        stop_using_completed: '이용중지가 완료 되었습니다',
        profit_margin: '이익율',
        profit_margin_fixed_required: '이익율 고정가는 필수입니다',
        profit_margin_change: '이익율 변경',
        no_profit_margin_change_history: '이익율 변경내역이 존재하지 않습니다',
        profit_margin_change_next_day_effect: '이익율 변경은 익일 적용 됩니다',
        profit_margin_setting: '이익율 설정',
        profit_margin_reservation_mandatory: '이익율 예약시 판매 이익율과 예정일은 필수입니다',
        profit_rate_required: '이익율은 필수입니다',
        before: '이전',
        below: '이하',
        day: '일',
        day_payment: '일 결제',
        day_sales: '일 매출',
        day_less_than: '{{lessDate}}일 미만',
        month_less_than: '{{lessMonth}}개월 미만',
        year_less_than: '{{lessYear}}년 미만',
        day_more_than: '{{moreDate}}일 이상',
        day_prior_product_disposal: '일 이전 상품 폐기',
        day_prior_product_disposal_inventory_adjustment: '일 이전 주문상품 가용재고 차감',
        day_day: '일 일',
        day_inventory: '일 재고',
        batch_exposure_setting: '일괄 노출 설정',
        batch_registration_form_download: '일괄 등록 양식 다운로드',
        batch_change: '일괄 변경',
        batch_edit_form_download: '일괄 수정양식 다운로드',
        batch_adjustment: '일괄 조정',
        batch_adjustment_irreversible_warning: '일괄 조정 시에는 데이터 원복이 불가능하므로 다시 한번 신중하게 확인 후 진행하시기 바랍니다.',
        batch_adjustment_completed: '일괄 조정이 완료 되었습니다',
        batch_confirmation: '일괄 확정',
        general_inquiry_details: '일반 문의 상세',
        general_inquiry: '일반문의',
        date_time: '일시',
        date_2: '일자',
        daily_inventory: '일재고',
        daily_inventory_product_selection: '일재고 상품 선택',
        daily_inventory_individual_order_impossible: '일재고 상품은 개별 발주가 불가능 합니다 발주 상품을 다시 확인해주시기 바랍니다',
        daily_inventory_order_center_requirement: '일재고 선택시, 주문가능센터는 1개 이상 입력 되어야 합니다',
        daily_inventory_only_disposal_possible: '일재고는 폐기만 가능',
        daily_inventory_no_joint_statement_with_storage: '일재고와 보관재고는 함께 정산서를 생성할 수 없습니다 확인 후 다시 선택해 주시기 바랍니다',
        daily_average_sales: '일평균 판매량',
        average_daily_sales_volume: '일평균판매량',
        view_imminent_products_only: '임박 상품만 보기',
        imminent_rate: '임박율',
        temporary_adjustment_limit_amount: '임시 조정 한도 금액',
        temporary_adjustment_limit_required: '임시 조정 한도 금액은 필수 입니다',
        temporary_adjustment_limit_end_date: '임시 조정 한도 적용 종료일',
        temporary_adjustment_limit_end_date_required: '임시 조정 한도 적용 종료일은 필수 입니다',
        temporary_order_restriction_date_setting: '임시 주문 제한일 설정',
        all_products_order_prohibited_during_period: '해당 기간에는 모든 상품 주문불가',
        individual_order_code: '개별 주문 코드',
        sender_name: '발송인명',
        sender_address: '발송인주소',
        sender_tel: '발송인전화번호',
        inventory_snapshot_excel_down: 'SKU 가용재고리스트',
        inventory_snapshot_detail_excel_down: '재고상세(로케이션, LOT, EXP)',
        inventory_excel_down: 'SKU 가용재고리스트',
        inventory_detail_excel_down: '재고상세(로케이션, LOT, EXP)',
        inbound: {
            receiving: '입고',
            receiving_management: '입고내역',
            receiving_unit: '입고 단위',
            receiving_available_days: '입고 가능 요일',
            receiving_available_days_required: '입고 가능 요일은 필수입니다',
            receiving_manager: '입고 담당자',
            receiving_manager_contact: '입고 담당자 연락처',
            waiting_for_receiving: '입고 대기',
            no_receiving_waiting_tasks: '입고 대기 작업이 없습니다',
            receiving_list: '입고 관리',
            receiving_deadline_time: '입고 마감 시간',
            receiving_deadline_time_required: '입고 마감 시간은 필수 입니다',
            enter_receiving_deadline_time: '입고 마감 시간을 입력 해주세요',
            receiving_shipping_info: '입고・배송 정보',
            receiving_settings: '입고 설정',
            receiving_center: '입고 센터',
            select_receiving_center: '입고 센터 선택',
            number_of_receivings: '입고 수',
            receiving_slots: '입고 슬롯',
            receiving_slot_list: '입고 슬롯 리스트',
            receiving_slot_list_product_details: '입고 슬롯 리스트 상품 상세',
            receiving_slot_details: '입고 슬롯 상세',
            receiving_slot_time: '입고 슬롯 시간',
            quantity_at_receiving: '입고 시 입수량',
            receiving_start_time: '입고 시작 시간',
            receiving_expected_time: '입고 예정 시간',
            receiving_start_time_fixed: '입고 시작 시간은 으로 고정',
            nighttime_receiving_slot: '입고 야간 슬롯',
            scheduled_receiving: '입고 예정',
            scheduled_receiving_time: '입고 예정 시간',
            scheduled_receiving_time_weekday_weekend: '입고 예정 시간(평일/주말)',
            scheduled_receiving_date: '입고(예정)일자',
            scheduled_receiving_document_storage: '입고 예정서 보관',
            scheduled_receiving_datetime: '입고 예정일시',
            receiving_quantity: '입고 수량',
            receiving_quantity_less_than_ordered:
                '입고 요청 수량보다 실입고 수량이 작습니다 선택하신 발주 내역이 입하 처리 되고 입고 확인서가 발행되며 이후에는 수정이 불가합니다 그래도 정말 강제 입고를 등록 하시겠습니까',
            requested_receiving_date: '입고 요청일',
            receiving_info: '입고 정보',
            receiving_expected_info: '입고 예정 정보',
            weekly_receiving_slot: '입고 주간 슬롯',
            processed_receiving_quantity: '입고 처리수량',
            processed_receiving_datetime: '입고 처리일시',
            receiving_code: '입고 코드',
            receiving_confirmation_process: '입고 확인 처리',
            receiving_confirmation_completed: '입고 확인 처리 되었습니다',
            receiving_confirmation_document: '입고 확인서',
            receiving_confirmation_final_document: '입고 확인서 입고 확정서',
            receiving_method: '입고 방식',
            completed_receiving_eligible_for_statement_creation:
                '입고가 완료된 내역 입고완료 상태 만 정산서 생성이 가능합니다 확인 후 다시 선택해 주시기 바랍니다',
            select_available_receiving_days: '입고가능 요일 선택',
            available_receiving_days_required: '입고가능 요일은 필수입니다',
            receiving_result: '입고결과',
            waiting_for_receiving_status: '입고대기',
            emergency_release_disabled_in_waiting_for_receiving: '입고대기 상태 긴급출고 비활성 처리',
            deadline_for_receiving: '입고마감',
            deadline_minutes_for_receiving_required: '입고마감 분은 필수 입니다',
            deadline_time_for_receiving_required: '입고마감 시간은 필수 입니다',
            closing_time_for_receiving: '입고마감시간',
            receiving_status: '입고상태',
            receiving_settings_completed: '입고설정 등록이 완료되었습니다',
            scheduled_receiving_center: '입고센터/입고예정일',
            scheduled_receiving_datetime_center: '입고센터/입고일시',
            receiving_center_required: '입고센터는 필수 입니다',
            received_quantity: '실제입고수량',
            received_quantity_unit: '입고수량/단위',
            received_quantity_order_unit: '입고수량/주문단위',
            stocking_slot_force_order_request_document_product_lookup: '입고슬롯 강제입고 발주요청서 상품 조회',
            scheduled_to_be_in_stock: '입고예정',
            expected_stock_quantity: '입고예정수량',
            expected_stock_quantity_order_unit: '입고예정수량/주문단위',
            expected_arrival_date: '입고예정일',
            expected_arrival_time: '입고예정시간',
            expected_plt_count: 'PLT수',
            expected_plt_count_time: 'PLT수 / 입고 시간',
            expected_arrival_date_time_count: '입고예정일 / 시간 / PLT수',
            stock_completed: '입고완료',
            receiving_request_more_than_stock_quantity: '입고요청 수량보다 실입고 수량이 많습니다 수량 조정해 주시기 바랍니다',
            stock_request_date: '입고요청일',
            select_stock_request_date: '입고요청일 선택',
            date_of_receipt: '입고일',
            date_of_receipt_period: '입고일 기간',
            date_of_arrival: '입고일시',
            place_of_receipt: '입고지',
            receiving_processing: '입고처리',
            receiver: '입고처리자',
            receiving_invoice_no: 'INVOICE NO',
            receiving_invoice_no_input: 'INVOICE NO 입력',
            confirm_receipt: '입고확인',
            receipt_confirmed_by: '입고확인자',
            search_receipt_confirmer: '입고확인자 검색',
            receipt_confirmer_info: '입고확인자 정보',
            select_receipt_confirmer: '입고확인자를 검색/선택 해주세요',
            confirmed_receipt: '입고확정',
            confirmed_receipt_date: '입고확정일',
            scheduled_receiving_quantity_input: '입고 예정 수량 입력',
            scheduled_receiving_quantity_unit: '입고예정수량 / 단위',
            total_amount: '총 입고 금액',
            receiving_expected_excel_registration: '입고예정서 엑셀 등록',
            receiving_expected_lot_no: '입고 예정 LOT 번호',
            receiving_expected_lot_no_input: '입고 예정 LOT 번호 입력',
            receiving_expected_goods_remark: '입고 상품 특이사항',
            receiving_expected_goods_remark_input: '입고 상품 특이사항 입력',
        },
        deposit: '입금',
        deposit_account_info: '입금 계좌 정보',
        deposit_processing: '입금 처리',
        deposit_amount_processing: '입금 처리 금액',
        deposit_reason: '입금 처리 사유',
        deposit_immediate_reflection: '입금 처리 시 즉시 채권에 반영되오니 확인 후 적용해 주시기 바랍니다',
        location_label_print_for_input_quantity: '입력 수량만큼 로케이션 라벨 출력',
        quantity_received: '입수량',
        quantity_received_per_order_unit: '입수량 주문단위',
        waiting_for_entry: '입차 대기중',
        entry_instructions_completed: '입차지시가 완료 되었습니다',
        in_stock_processing: '입하 처리',
        in_stock_processing_completed: '입하 처리가 되었습니다',
        automatic: '자동',
        automatic_ordering: '자동 발주',
        automatic_ordering_manual: '자동 발주 수동 발주',
        automatic_declaration_processing: '자동 신고 처리',
        automatic_refund: '자동 환불',
        automatic_ordering_not_available: '자동발주를 선택할 수 없습니다',
        seating_required: '6자리 이상 입력하여 주십시오',
        frequently_asked_questions: '자주 묻는 질문',
        faq_registration_completed: '자주 묻는 질문 등록이 완료되었습니다',
        faq_deletion: '자주 묻는 질문 삭제',
        faq_details: '자주 묻는 질문 상세',
        faq_modification: '자주 묻는 질문 수정',
        faq_registration: '자주 묻는 질문 등록',
        self_disposal: '자체 폐기',
        no_work_without_history: '작업 내역 없으면 실행되지 않도록',
        no_work_target_list: '작업 대상 목록이 없습니다',
        work_completion_datetime: '작업완료일시',
        select_option_for_work_instruction: '작업을 지시할 옵션을 선택해주세요',
        remaining_amount: '잔량',
        remaining_days: '잔여일',
        remaining_days_count: '잔여일수',
        frequent_mass_data_upload_warning:
            '잦은 대량 데이터 업로드는 서버 부하를 일으킬 수 있으며, 고객 주문 또는 출고에 영향을 미칠 수 있으니 한번 더 파일을 확인하시기 바랍니다',
        frequent_statement_creation_deletion_warning:
            '잦은 정산서 생성 삭제는 시스템 과부하의 주요 원인 이므로 다시 한번 확인 후 신중하게 처리 하시기 바랍니다',
        re_recovery_status: '(재)회수상태',
        re_recovery_scheduled_date: '(재)회수예정일',
        re_recovery_completion_date: '(재)회수완료일',
        re_recovery_code: '(재)회수코드',
        contract_renewal: '재계약',
        contract_renewal_termination: '계약 종료',
        contract_renewal_processed: '재계약 처리 되었습니다',
        contract_renewal_processing_warning:
            '재계약 처리 시에는 신규 가상계좌번호가 부여되며 기존 계약정보가 원복되오니 반드시 재확인 후 시도해주시기 바랍니다.',
        contract_renewal_confirmation: '재계약 처리 하시겠습니까',
        contract_renewal_completed: '재계약 처리가 완료 되었습니다',
        inventory_classification_1: '재고 구분',
        inventory_classification_2: '재고구분',
        inventory_order_classification: '재고 구분 / 발주 구분',
        inventory_list: '재고 리스트',
        inventory_snapshot_list: '재고 리스트 스냅샷',
        inventory_list_details: '재고 리스트 상세',
        inventory_replenishment: '재고 보충',
        inventory_replenishment_order: '재고 보충 지시',
        inventory_discrepancy_view_only: '재고 불일치 상품만 보기',
        inventory_depletion_view_only: '재고 소진 상품만 보기',
        inventory_depletion_rate: '재고 소진율',
        inventory_quantity: '재고 수량',
        inventory_ledger_finalization: '재고 수불부 확정',
        inventory_ledger_finalization_confirmation: '재고 수불부 확정 처리를 하시는 경우 비밀번호를 입력해주세요',
        inventory_information: '재고 정보',
        inventory_audit: '재고 조사',
        last_week_1: '저번주',
        low_temperature: '저온',
        low_temperature_frozen: '저온 냉동',
        save: '저장',
        save_register: '등록',
        save_add: '저장 추가',
        save_confirm: '저장·확정',
        save_completed: '저장이 완료 되었습니다',
        apply_period: '적용 기간',
        apply_edit: '적용 수정',
        apply_start_date: '적용 시작일',
        apply_end_date: '적용 종료일',
        select_apply_end_date: '적용 종료일 선택',
        number_of_applicable_products: '적용상품수',
        expected_date_of_application: '적용예정일',
        expected_date_of_application_required: '적용예정일은 필수 입니다',
        date_of_application: '적용일',
        until_the_date_of_application: '적용일까지 기존 여신 한도 금액이 임시 조정 한도 금액으로 변경 됩니다',
        date_of_application_required: '적용일자는 필수 입니다',
        applying: '적용중',
        accumulation_amount: '적치 SKU 수',
        accumulation_period: '적치기간',
        status_of_accumulation: '적치상태',
        accumulation_rate: '적치율',
        accumulation_rate_replenishment_order: '적치율 기준 보충 지시',
        view_below_accumulation_rate: '적치율 {{automaticReplenishmentLessPercent}}%미만 보기',
        automatic_replenishment_below_accumulation_rate:
            '*적치율이 {{automaticReplenishmentLessPercent}}% 미만으로 떨어지는 경우 자동으로 재고 보충 지시 됩니다',
        jeonnam: '전남',
        computation_expiration_date: '전산 유통기한',
        computation_quantity: '전산 수량',
        forwarding: '전송',
        exclusive_products: '전용 상품',
        entire: '전체',
        register_as_entire_exposure: '전체 노출 상태로 등록',
        register_as_entire_non_exposure: '전체 미노출 상태로 등록',
        entire_non_exposed_included: '전체 미노출 상품이 포함되어있습니다',
        entire_non_exposed_product: '전체 미노출 상품입니다',
        view_all_products: '전체 상품보기',
        entire_receiving_results: '전체 입고결과',
        view_entire_receiving_history: '전체 입고내역 보기',
        entire_receiving_status: '전체 입고상태',
        entire_receiving_slots: '전체 입고슬롯',
        entire_picking_list: '전체 피킹 리스트',
        entire_total_amount: '전체 합계 금액',
        phone_number: '전화번호',
        enter_phone_number: '전화번호 입력',
        enter_phone_number_prompt: '전화번호를 입력하세요',
        enter_phone_number_please: '전화번호를 입력해주세요',
        lunch: '점심 시간',
        lunch_start_time: '점심 시작 시간',
        lunch_end_time: '점심 종료 시간',
        lunch_time_required: '점심시간은 필수 설정해야 저장이 가능합니다',
        no_access_rights: '접근권한이 없습니다',
        receipt_reason: '접수 사유',
        receipt_reason_required: '접수 사유는 필수입니다',
        receipt_quantity: '접수 수량',
        acceptable_quantity: '접수가능수량',
        reason_for_submission: '접수사유',
        date_of_receipt: '접수일',
        confirm_receipt_change: '접수하신 상담 상태를 변경하시겠습니까',
        really_delete_reservation: '정말 변경예약건을 삭제 하시겠습니까',
        really_delete: '정말 삭제하시겠습니까',
        really_delete_holiday: '정말 휴일을 삭제하시겠습니까',
        information: '정보',
        copy_information: '정보 복사',
        batch_edit_information: '정보 일괄 수정',
        batch_edit_information_file: '정보 일괄 수정 - Excel 파일',
        settlement_payment_date: '정산 결제일',
        settlement_payment_date_required: '정산 결제일은 필수 입니다',
        settlement_base_date: '정산 기준일',
        settlement_base_date_cannot_be_earlier: '정산 기준일은 결제일보다 빠를 수 없습니다',
        settlement_base_date_required: '정산 기준일은 필수 입니다',
        settlement_edit: '정산 수정',
        settlement_total_amount: '정산 합계금액',
        confirm_settlement: '정산 확정',
        settlement_classification: '정산구분',
        settlement_period: '정산기간',
        settlement_standard_payment_date: '정산기준 (결제일)',
        settlement_date: '정산기준일',
        settlement_year_and_month: '정산년월',
        settlement_status: '정산상태',
        settlement_document: '정산서',
        settlement_document_ID: '정산서 ID',
        renew_settlement_document: '정산서 갱신',
        settlement_document_purchase_station: '정산서 매입처 매입처',
        view_uncreated_settlement_document: '정산서 미생성 내역만 보기',
        add_return_details_to_settlement_document: '정산서 반품 내역 추가',
        delete_settlement_document: '정산서 삭제',
        create_settlement_document: '정산서 생성',
        settlement_document_creation_completed: '정산서 생성이 완료 되었습니다',
        edit_settlement_document: '정산서 수정',
        resend_settlement_document_1: '정산서 재전송',
        settlement_document_modification_not_possible: '정산서 확정 이후에는 수정이 불가',
        settlement_document_modification_not_possible2: '하며, 정산서가 발송됩니다.',
        settlement_document_sent: '정산서가 발송됩니다.',
        settlement_document_modification_not_possible_due_to_creation: '정산서가 생성되어 있어 매입가 수정이 불가합니다',
        resend_settlement_document_2: '정산서를 재전송',
        resend_settlement_document_prompt: '정산서를 재전송 하시겠습니까?',
        frequent_creation_deletion_of_settlement_document:
            '정산서의 잦은 생성 삭제는 시스템 과부화의 주요 원인이므로 다시 한번 확인 후 신중하게 처리 하시기 바랍니다',
        check_settlement_document: '정산서확인',
        settlement_date_required: '정산일은 필수 입니다',
        normal: '정상',
        normal_operation_close: '정상 동작하면 닫기 처리',
        normal_success: '정상 성공',
        normal_shipping_processing: '정상 출고 처리',
        normal_shipping_no_logistics_code: '정상 출고 - 처리 선택된 물류코드가 없습니다',
        normal_shipping_completed: '정상 출고 처리 완료 되었습니다',
        normal_shipping_confirm: '정상 출고 처리 하시겠습니까',
        order_transferred_normally: '정상적으로 주문이 이관되었습니다',
        correction_request_management_return: '정정요청관리반품',
        suspension_date: '정지일',
        warning_confirm_inout_history: '재고수불부 최종 확정 처리 하시겠습니까?\n확정 처리후에는 수정 불가합니다.',
        finalization_inout_history: '재고수불부 확정',
        completed_inout_history: '재고수불부 확정이 완료되었습니다',
        inout_history: '재고수불부',
        empty_page_inout_history: '재고수불부',
        title: '제목',
        title_required: '제목은 필수입니다',
        enter_title: '제목을 입력하세요',
        product_inquiry: '제품문의',
        investigation_result_reflection: '조사 결과 반영 여부',
        select_investigation_result_reflection: '조사 결과 반영 여부를 선택하세요',
        select_investigation_year: '조사 년도 선택',
        investigation_year_query: '조사 년도 조회',
        investigation_status_1: '조사 상태',
        select_investigation: '조사 선택',
        investigation_expiration_date: '조사 유통기한',
        investigation_quantity: '조사 수량',
        investigation_lot: '조사 LOT',
        investigation_upload: '조사 업로드',
        investigation_status_check_1: '조사 여부',
        completed_investigation_unsurveyed: '조사 여부 완료 미조사',
        investigation_completion_datetime: '조사 완료 일시',
        investigation_datetime: '조사 일시',
        investigation_order_datetime: '조사 지시 일시',
        survey_year: '조사년도',
        investigation_status_2: '조사상태',
        investigation_status_check_2: '조사여부',
        adjustment: '조정',
        adjustment_classification: '조정 구분',
        adjustment_classification_required: '조정 구분은 필수 입니다',
        adjustment_amount: '조정 금액',
        adjustment_date_1: '조정 년월일',
        adjustment_reason: '조정 사유',
        enter_adjustment_reason: '조정 사유 입력',
        adjustment_reason_detailed: '조정 사유가 상세히 작성되지 않은 경우 조정 내역이 반려될 수 있습니다',
        enter_adjustment_reason_prompt: '조정 사유를 입력해주세요',
        adjustment_expiration_date: '조정 유통기한 년월일',
        adjustment_quantity: '조정 수량',
        enter_adjustment_quantity: '조정 수량 입력',
        enter_adjustment_lot_no: '조정 LOT번호 입력',
        prompt_adjustment_quantity: '조정 수량을 입력해 주세요',
        adjustment_impacts_reservation: '조정 시 기존 예약 정보는 사라지며 변경 내용으로 일괄 적용됩니다',
        adjustment_type_1: '조정 유형',
        select_adjustment_type: '조정 유형 선택',
        choose_adjustment_type: '조정 유형을 선택해 주세요',
        adjustment_effective_date: '조정 적용일',
        adjustment_before_expiration: '조정 전 유통기한',
        adjustment_before_lot_no: '조정 전 LOT',
        adjustment_before_quantity: '조정 전 수량',
        adjustment_method_required: '조정 처리 방식은 필수 입니다',
        adjustment_confirm: '조정 확정',
        adjustment_after_expiration: '조정 후 유통기한',
        adjustment_after_lot_no: '조정 후 LOT',
        adjustment_after_quantity: '조정 후 수량',
        adjustment_category: '조정구분',
        adjustment_fee: '조정금',
        adjustment_fee_details: '조정금 내역',
        adjustment_fee_processing: '조정금 처리',
        adjustment_fee_processing_query: '조정금 처리 내역 조회',
        no_adjustment_fee_processing: '조정금 처리 내역이 없습니다',
        adjustment_fee_processing_target: '조정금 처리 대상중 선불 발주처가 존재합니다',
        adjustment_fee_processing_impact:
            '조정금 처리 시 조정금액이 즉시 채권에 반영되며,정산서에 반영 청구 되오니 다시 한번 확인 후 처리하시기 바랍니다',
        no_adjustment_fee_details: '조정금 처리내역이 없습니다',
        adjustment_fee_processing_unavailable: '조정금 처리를 할 수 없습니다',
        select_adjustment_fee_liability: '조정금 처리에 따른 귀책 선택',
        select_adjustment_fee_category: '조정금 처리에 따른 카테고리 선택',
        adjustment_amount_added: '조정금액 추가가 완료 되었습니다',
        reason_for_adjustment: '조정사유',
        adjusted_quantity: '조정수량',
        adjustment_type_2: '조정유형',
        adjustment_type_expiration_adjustment: '조정유형 유통기한 조정',
        adjustment_type_disposal_loss_recovery: '조정유형 폐기 손망실 처리 손망실복구',
        adjustment_date_2: '조정일',
        coordinator: '조정자',
        search_coordinator: '조정자 검색',
        coordinator_info: '조정자 정보',
        select_coordinator: '조정자를 검색 선택 해주세요',
        adjustment_processing_datetime: '조정처리 년월일 시분',
        adjustment_processing_details: '조정처리내용',
        adjustment_processor: '조정처리자',
        approved_by_organization_leader: '조직장 팀장 승인이 완료 된 건입니다',
        calculate_date_from_today: '조회 날짜 계산 현재기준으로 일',
        search_basis: '조회기준',
        no_incoming_logistics_details_found: '조회된 간선 입고 내역이 없습니다',
        no_results_found: '조회된 결과가 없습니다',
        no_details_found: '조회된 내역이 없습니다',
        no_contents_found: '조회된 내용이 없습니다',
        no_inventory_info_found: '조회된 재고 정보가 없습니다',
        no_order_details_found: '조회된 주문 내역이 없습니다',
        view_only_terminated_products: '종결 상품만 보기',
        terminated_products_included: '종결 상품이 포함되어 있습니다 발주 상품을 다시 확인해주시기 바랍니다',
        end: '종료',
        end_date: '종료일',
        end_date_required: '종료일은 필수 입니다',
        imminent_termination: '종료임박',
        employee_id: '종사업자번호',
        main_weekly_delivery: '주 {{weeklyDeliveryCount}}일 배송',
        weekly: '주간',
        day_night_cycle: '주간 야간',
        weekend: '주말',
        weekend_closure: '주말 마감',
        no_weekend: '주말 없음',
        order: '주문',
        order_available_center: '주문 가능 센터',
        order_management: '출하 관리',
        order_received: '주문 접수',
        order_management_excel_download: '출하 관리 엑셀 다운로드',
        order_management_detail_excel_download: '출하 관리 상세 엑셀 다운로드',
        order_management_excel_upload_failure: '출하 관리 엑셀 업로드 실패',
        order_amount: '주문 금액',
        order_history: '주문 내역',
        excel_month_limit: '엑셀 다운로드는 최대 31일 까지만 가능합니다. 조회 기간을 31일 이내로 다시 선택해 주세요.',
        no_order_history: '주문 내역이 없습니다',
        order_download_limit: '주문 다운로드는 {{totalOrderExcelDownload}} 건까지만 가능합니다',
        order_unit: '주문 단위',
        order_unit_specification: '주문 단위 규격',
        order_deadline: '주문 마감 시간',
        order_deadline_required: '주문 마감 시간은 필수 입니다',
        order_deadline_format_incorrect: '주문 마감시간 양식에 맞지 않습니다',
        order_sales_selection: '주문(매출) 선택',
        order_frequency: '주문 빈도',
        order_detail: '주문 상세',
        order_products: '주문 상품',
        order_quantity: '주문 수량',
        order_upload: '주문 업로드',
        order_AdrVerify: '주소 검증',
        order_upload_limit: '주문 업로드는 한 번에 최대 {{orderUploadLimit}}개 까지 가능합니다.',
        order_upload_brand_warning: '하나의 수주번호에는 동일 브랜드의 상품만 업로드해 주세요.',
        order_moment: '주문 일시',
        order_info_excel_file: '주문 정보 EXCEL 파일',
        order_content: '주문 주문 내용',
        cancel_order: '주문 취소',
        order_cancellation_process: '주문 취소 시',
        order_cancellation_no_logistic_code: '주문취소 - 선택된 출고 물류코드가 없습니다.',
        order_cancellation_no_orders: '선택된 주문이 없습니다.',
        order_cancellation_immediate: '주문 취소 시 상품을 즉시 주문 취소합니다. 주문 취소 시 자동 환불 되므로 신중하게 확인 후 처리하시기 바랍니다.',
        order_receive_cancellation: '주문 취소 시 상품을 즉시 주문 취소합니다. 주문을 취소하시겠습니까?',
        order_cancellation_completed: '주문 취소 완료 되었습니다',
        order_amount_vat_included: '주문금액은 VAT 포함',
        order_unit_temperature: '주문단위 / 품온',
        order_deadline_minute_weekend: '주문마감분 주말 은 자리로 입력하여 주십시오',
        order_deadline_minute_weekday: '주문마감분 평일 은 자리로 입력하여 주십시오',
        order_deadline_weekend: '주문마감시간 주말',
        order_deadline_weekend_required: '주문마감시간 주말 은 자리로 입력하여 주십시오',
        order_deadline_weekday: '주문마감시간 평일',
        order_deadline_weekday_required: '주문마감시간 평일 은 자리로 입력하여 주십시오',
        order_number: '주문번호',
        order_unavailable_days: '주문불가 요일',
        order_status: '주문상태',
        ordered_product_inventory_deduction: '주문상품 가용재고 차감',
        order_selection: '주문선택',
        order_date_query: '주문일 조회',
        order_date_and_time: '주문일시',
        receipt_date_and_time: '접수일시',
        receipt_date: '접수일',
        address_verification: '주소검증',
        address_verified: '통과',
        address_unverified: '주소 미검증',
        outbound_requestable: '요청가능',
        outbound_request_done: '요청됨',
        outbound_request_failed: '요청실패',
        outbound_fail_not_received: '접수상태 아님',
        outbound_fail_stock_shortage: '재고부족',
        outbound_fail_invoice_rejected: '송장채번 거절',
        outbound_fail_no_history: '실패 이력이 없습니다',
        outbound_fail_date: '일시',
        label_partially_printed: '송장 {{count}}건이 출력되지 않았습니다. 목록을 파일로 저장했습니다.',
        order_channel: '주문채널',
        select_order_channel: '주문채널 선택',
        withdraw_order: '주문취소',
        withdraw_order_no_logistics_code: '주문취소 선택된 출고 물류코드가 없습니다',
        order_code: '주문코드',
        purchase_code: '수주번호',
        search_order_code: '주문코드 검색',
        order_code_sales_product_name: '주문코드 발주처 발주처 상품 상품명',
        order_confirmed: '주문확정',
        address: '주소',
        search_address: '주소 검색',
        address_detail: '주소 상세',
        address_search: '주소검색',
        address_required: '주소는 필수 입니다',
        precautions_confirmed: '주의사항을 확인하였습니다',
        preparing: '준비중',
        current_excel_coming_soon: '현재 엑셀 다운로드 기능을 준비 중 입니다.',
        duplicated_category_name: '중복된 카테고리명이 존재합니다',
        middle_classification: '중분류',
        select_middle_classification: '중분류 선택',
        middle_classification_required_if_adding: '중분류 카테고리 추가시 대분류는 필수입니다',
        middle_classification_required: '중분류 카테고리는 필수입니다',
        middle_classification_is_required: '중분류는 필수 입니다',
        immediate_regulation_termination: '즉시 규제 종료',
        favorites_only: '즐겨찾기만 보기',
        payment_amount_3: '지급액',
        last_month: '지난달',
        last_week_2: '지난주',
        branch_line: '지선',
        branch_route: '지선 라우트',
        branch_route_detail: '지선 라우트 상세',
        adjust_feeder_route: '지선라우트 수정',
        instruction: '지시',
        irreversible_instruction_warning: '지시 후에는 되돌릴 수 없으며 다음 작업 단계로 넘어갑니다',
        no_inventory_replenishment_instruction: '지시된 재고보충 내역이 없습니다',
        indicator: '지시자',
        search_indicator: '지시자 검색',
        indicator_info: '지시자 정보',
        select_indicator: '지시자를 검색 선택 해주세요',
        designation_needed: '지정 필요',
        direct_shipping: '직송',
        direct_shipping_order_impossible: '직송 상품은 개별 발주가 불가능 합니다 발주 상품을 다시 확인해주시기 바랍니다',
        direct_shipping_receipt: '직송 입고 확인서',
        direct_input: '직접 입력',
        direct_input_selection: '직접입력 선택한 경우',
        entry_method_details: '진입방법상세',
        progress_status: '진행상태',
        in_progress: '진행중 조사 로케이션수 총 로케이션 수',
        deducted: '차감',
        deducted_payment_amount: '차감 지급액',
        vehicle: '차량 정보',
        no_vehicle_information: '차량 정보 없음',
        vehicle_classification_fixed_departures: '차량구분 : 고정 / 출차횟수 : {{totalDlv}}',
        vehicle_number: '차량번호',
        vehicle_number_more: '차량번호 더',
        vehicle_number_maximum_entries: '차량번호 최대 10자리를 입력해주세요',
        vehicle_number_minimum_entries: '차량번호 최소 7자리를 입력해주세요',
        vehicle_number_required: '차량번호를 필수로 입력해주세요',
        vehicle_cost: '차량비용',
        vehicle_information: '차량정보',
        vehicle_information_details: '차량정보 정보',
        landing: '착지',
        select_landing: '착지 선택',
        find: '찾기',
        bonds: '채권 관리',
        bonds_management_suspended: '채권 관리가 정지되며 한도금액 내에서 즉시 주문이 가능합니다',
        bonds_balance: '채권 잔액',
        no_bond_details: '채권내역이 존재하지 않습니다',
        bond_status: '채권상태',
        bond_balance_currency: '채권잔액',
        treatment: '처리',
        treatable_quantity: '처리 가능 수량',
        treatment_result_search: '처리 결과 검색 재조회',
        treatment_result_warning: '처리 결과는 수정이 불가하오니',
        treatment_classification: '처리 구분',
        treatment_amount: '처리 금액',
        treatment_details: '처리 내용',
        enter_treatment_details: '처리 내용 입력',
        treatment_details_required: '처리 내용은 필수입니다',
        detailed_treatment_required: '처리 내용은 필수입니다 처리내용은 자리 이하로 입력하여 주십시오',
        enter_treatment_details_prompt: '처리 내용을 입력하세요',
        treatment_method: '처리 방식',
        treatment_reason: '처리 사유',
        treatment_status_required: '처리 상태 필수입니다',
        select_treatment_product: '처리 상품 선택',
        select_treatment: '처리 선택',
        treatment_quantity_exceeds: '처리 수량은 실배송수량을 초과할 수 없습니다',
        treatment_completed: '처리 완료',
        treatment_request: '처리 요청',
        treatment_type: '처리 유형',
        treatment_datetime: '처리 일시',
        treatment_date_required: '처리 적용일은 필수 입니다',
        treatment_needed: '처리 필요',
        quantity_that_can_be_processed: '처리가능수량',
        number_of_cases_processed: '처리건수',
        processing_result: '처리결과',
        address_delete_fail: 'Etomars ERROR 개발팀에 문의해주세요',
        processing_classification: '처리구분',
        select_processing_classification: '처리구분을 선택하세요',
        processing_details: '처리내용',
        processing_details_detail: '처리내용 상세',
        processing_details_limit: '처리내용은 {{processingDetail}} 자리 이하로 입력하여 주십시오',
        processing_manager: '처리담당자',
        reason_for_processing: '처리사유',
        reason_for_processing_required: '처리사유는 선택 필수입니다',
        reason_for_processing_mandatory: '처리사유는 필수입니다',
        processing_status: '처리상태',
        processing_status_mandatory: '처리상태 필수',
        processing_quantity: '처리수량',
        enter_processing_quantity: '처리수량 입력',
        enter_processing_quantity_prompt: '처리수량을 입력하세요',
        processing_time: '처리시점',
        processing_confirmation: '처리여부',
        processing_completed: '처리완료',
        processing_type: '처리유형',
        processing_type_reason: '처리유형 / 사유',
        processing_date: '처리일',
        processing_date_responsible_person: '처리일 / 처리자',
        processing_datetime: '처리일시',
        processing_date_query: '처리일자',
        processing_responsible: '처리자',
        search_processing_responsible: '처리자 검색',
        select_processing_handler: '처리자를 검색 선택 해주세요',
        processing_in_progress: '처리중',
        processing_history_only: '처리중 이력만 보기',
        execute_processing: '처리하기',
        cheonan: '천안',
        attach_contract_documents: '첨부 계약 서류',
        attach_file: '첨부 파일',
        attachment: '첨부파일',
        check_when_registering: '체크 시 해당 계정으로 등록한 이력 중 처리중 내역만 노출',
        checkbox: '체크박스 양품화 반품 폐기',
        checked_amount_and_reason: '체크한 항목에 대해서 금액과 사유를 입력해주세요',
        initial_target_setting: '초기 대상 설정',
        initial_month: '초기 월',
        reset: '초기화',
        initialization_processing: '초기화처리',
        total_1: '총',
        total_count_1: '총 {{basicTotal}} 개',
        total_route_count: '총 {{totalRoute}} 개 라우트',
        total_amount_in_thousands: '총 개 만원',
        total_sales_details: '총 개 매출 내역',
        total_sales_source: '총 {{totalSalesSource}}개 발주처',
        total_logistics_code_count: '총 {{totalLogisticCode}}개 물류코드',
        total_logistics_code_selection: '총 {{totalLogisticCode}}개 물류코드 선택',
        total_products: '총 {{totalProducts}} 개 상품',
        total_packages: '총 {{totalPackages}} 개 패키지',
        total_positive_records: '총 {{totalPositive}} 개 양수 내역',
        total_entries: '총 개의',
        total_trading_companies: '총 {{tradingCompanies}} 개의 거래법인',
        total_announcements: '총 {{totalAnnouncements}} 개의 공지사항',
        total_urgent_dispatch_history: '총 {{totalUrgent}} 개의 긴급출고 이력',
        total_locations: '총 {{totalLocation}}개의 로케이션',
        total_purchase_history: '총 {{totalPurchaseHistory}} 개의 매입 내역',
        total_inbound_history: '총 {{totalPurchaseHistory}} 개의 입고 내역',
        total_inbound_expected_qty: '총 {{qty}} 개의 입고 예정 수량',
        total_inbound_qty: '총 {{qty}} 개의 입고 수량',
        total_suppliers: '총 {{totalPurchaser}} 개의 브랜드',
        total_sales_outlets: '총 {{totalCustomer}} 개의 발주처',
        total_sales_outlets_selection: '총 {{totalSelectedSales}}개의 발주처 선택',
        total_unassigned_sales_outlets: '총 {{total}} 개의 미배정 발주처',
        total_return_exchange_history: '총 {{returnExchange}} 개의 반품 & 교환 이력',
        total_return_details: '총 {{totalReturn}} 개의 반품 내역',
        total_sale_history: '총 {{totalSaleHistory}} 개의 매출 내역',
        total_change_history: '총 {{totalChangeHistory}}개의 변경이력',
        total_sluggish_inventory: '총 {{totalSluggishInventory}} 개의 부진재고',
        total_brands: '총 {{totalBrand}}개의 브랜드',
        total_consultation_history: '총 {{totalConsultationHistory}} 개의 상담 이력',
        total_items: '총 {{totalGoods}} 개의 상품',
        total_modification_history: '총 {{totalModificationHistory}}개의 수정이력',
        total_modification_items: '총 {{totalModificationItem}}개의 수정항목',
        total_issue_details: '총 {{totalIssue}} 개의 이슈 내역',
        total_inventory_history: '총 {{totalInventoryHistory}} 개의 재고이력',
        total_frequently_asked_questions: '총 {{totalQuestions}} 개의 자주 묻는 질문',
        total_statements: '총 {{settlementTotal}} 개의 정산서',
        total_adjustment_details: '총 {{totalAdjustmentHistory}} 개의 조정 내역',
        total_bonds: '총 {{totalBonds}} 개의 채권',
        total_claim_history: '총 {{totalClaimHistory}} 개의 클레임 이력',
        total_recovery_details: '총 {{totalRecoveryHistory}}개의 회수 내역',
        total_cases: '총 {{totalBasic2}} 건',
        total_box: '총 {{totalBox}} 박스',
        total_sum_qty: '총 합계 수량 {{totalQty}} EA',
        confirm_total_case_download: '총 {{totalHistory}} 건 의 내역을 다운로드 하시겠습니까',
        confirm_total_order_details_download: '총 {{totalOrderDetailExcelDownload}} 건 주문을 다운로드 하시겠습니까',
        total_urgent_dispatch_vehicle_cost: '총 {{totalUrgent}} 건의 긴급배차',
        total_purchase_order_history: '총 {{totalPurchaseOrderHistory}}건의 발주내역',
        total_labels: '총 라벨수',
        total_sales_outlets_count: '총 발주처 수',
        total_managers: '총 {{totalManager}} 명의 매니저',
        total_order_amount: '총 발주금액',
        total_dispatch_cost: '총 배차비용',
        total_product_count: '총 상품 수',
        total_count: '총 수',
        total_file_size_limit: '총 파일 사이즈는 {{totalFileSizeLimit}}MB를 넘을 수 없습니다',
        total_refund_scheduled_amount: '총 환불(예정) 금액',
        total_virtual_account_amount: '총 {{totalVirtualAccount}} 개 가상계좌',
        total_sessions: '총 {{totalCount}} 회',
        total_trading_volume: '총거래량',
        total_picking_output: '총량 피킹지 출력',
        print_all_searched_list: '조회된 리스트 전체를 출력하시겠습니까?',
        recent_order_amount_last_days: '최근 일 주문금액',
        recent_order_frequency_last_days: '최근 일 주문횟수',
        recent_order_details_last_days: '최근 {{recentOrderDay}} 일의 주문내역이 노출됩니다',
        maximum_storage_capacity: '최대보관량',
        minimum_order: '최소 주문',
        minimum_order_quantity: '최소 주문 수량',
        enter_minimum_order_quantity: '최소 주문수량 입력',
        minimum_order_quantity_required: '최소 주문수량은 필수 입니다',
        select_at_least_one_order_item: '최소 하나의 주문 품목을 선택하세요',
        final_fault: '최종 귀책',
        final_fault_required: '최종 귀책은 필수입니다',
        final_end_of_period: '최종 기말',
        final_consultation_type: '최종 상담유형',
        final_consultation_type_required: '최종 상담유형은 필수입니다',
        final_detail_type_required: '최종 상세유형은 필수입니다',
        final_modification: '최종 수정',
        final_completion_date: '최종 처리완료일',
        select_final_fault: '최종귀책을 선택하세요',
        last_change_datetime: '최종변경일시',
        final_quantity: '최종수량',
        last_modified: '최종수정',
        initial_registration: '최초 등록',
        initial_registration_last_modification: '최초 등록 / 최종 수정',
        initial_registrar: '최초 등록자',
        addition: '추가',
        livestock_product_history_report_needed: '축산물이력신고 필요 여부',
        livestock_product_history_reporting_required: '축산물이력신고 필요여부',
        livestock_product_history_report_number: '축산물이력신고번호',
        delivery_processing: '출고 처리',
        shipping_price_notice: '출고가 불가능한 경우 확인 후 직접 취소 처리 하시기 바랍니다',
        in_shipment_quantity_note: '출고량에 따라 다소 시간이 소요될 수 있습니다',
        expected_to_be_shipped: '출고예정',
        expected_warehouse_delivery_date: '출고예정일',
        empty_page_expected_to_be_shipped: '출고 예정 내역이 없습니다.',
        delivery_warehouse_type: '출고유형',
        shipping_issue_details: '출고이슈 상세',
        shipping_date_requirement: '출고일 변경시 출고일은 필수입니다',
        change_delivery_date: '출고일변경',
        delivery_datetime: '출고일시',
        shipping_work_instruction: '출고작업',
        shipping_work_in_progress: '출고작업 지시 중입니다',
        shipping_work_progress_popup: '출고작업 진행중 팝업',
        shipping_order_instruction: '출고지시',
        shipping_order_failure: '출고지시 실패',
        shipping_processing_status: '출고처리',
        shipping_processing_result: '출고처리 되었습니다 (성공:{{successCount}} 실패:{{failCount}})',
        delivery_turn: '출고 회차',
        select_delivery_turn: '출고 회차 선택',
        print_total_picking_list: '{{outboundCounts}}개의 출고회차의 총량 피킹지를 출력하시겠습니까?',
        print_piece_picking_list: '{{outboundCounts}}개의 출고회차의 개별 피킹지를 출력하시겠습니까?',
        please_select_delivery_turn: '출고 회차를 지정 해주세요.',
        please_select_only_one_delivery_turn: '라벨 출력 시 출고 회차는 한 건만 가능합니다.',
        delivery_turn_format_example: 'YYMM-n (예: 2511-1, 2511-2)',
        output_of_power: '출력',
        output_of_power_quantity: '출력 라벨 수량',
        to_print_no_shipping_work: '출력할 간선 출고 작업이 없습니다',
        to_print_no_transaction_statement: '출력할 거래명세서가 없습니다',
        to_print_no_picking_turn: '출력할 피킹 회차가 없습니다',
        to_send_invoice_bulk: '송장발행할 주문이 선택되지 않았습니다.',
        to_print_no_delivery_order: '출력할 납품서가 없습니다.',
        to_print_no_outbound_label: '출력할 라벨이 없습니다.',
        depart_from_location_code: '출발 로케이션 코드',
        departure_center: '출발센터',
        origin_information: '출발지 정보',
        exit_delivery_management: '출차 배송관리',
        exit_center: '출차 센터',
        change_exit_center: '출차 센터 변경',
        exit_center_change_completed: '출차 센터 변경이 완료 되었습니다',
        batch_change_of_exit_center: '출차 센터 일괄 변경',
        weekday_exit_center_input_time: '출차 - {{inboundCenterName}} 입고 (예정시간 : 평일 -',
        outbound_delivery_management: '출차배송관리',
        departure_center_update: '출차센터',
        change_of_exit_center: '출차센터변경',
        departure_center_code: '출차센터코드',
        departure_datetime: '출차일시',
        departure_point: '출차지',
        select_departure_point: '출차지 선택',
        departure_center_point_required: '출차지 센터는 필수 입니다',
        cancellation: '취소',
        cancellation_warning: '취소 후에는 재처리가 불가합니다',
        has_been_canceled: '취소되었습니다',
        cancellation_status: '취소상태',
        cancellation_quantity: '취소수량',
        category: '카테고리',
        category_management: '카테고리 관리',
        category_immutable_once_registered: '카테고리 등록 후에는 삭제 및 수정이 불가 합니다',
        category_change: '카테고리 변경',
        category_change_area: '카테고리 변경 영역',
        category_change_completed: '카테고리 변경이 완료 되었습니다',
        category_deletion: '카테고리 삭제',
        category_deletion_completed: '카테고리 삭제가 완료 되었습니다',
        select_category: '카테고리 선택',
        category_selection_required: '카테고리 선택은 필수 입니다',
        add_category: '카테고리 추가',
        category_addition_completed: '카테고리 추가가 완료 되었습니다',
        category_code: '카테고리 코드',
        category_code_required: '카테고리 코드는 필수 입니다',
        category_name: '카테고리명',
        enter_and_add_category_name: '카테고리명을 입력하고 추가해주세요',
        enter_category_name: '카테고리명을 입력하세요',
        please_enter_category_name: '카테고리명을 입력해주세요',
        category_name_code_duplicate: '카테고리명이 중복되었습니다 카테고리 코드가 중복되었습니다',
        by_category_default_purchase_profit_rate: '카테고리별 기본 구매 이익율',
        by_category_set_profit_rate: '카테고리별 설정한 이익율에 따라 정해진 판매가',
        category_profit_rate_setting: '카테고리별 이익율 설정',
        code: '코드',
        quick_cost: '퀵비용',
        by_clicking: '클릭하여 파일 추가',
        by_clicking_maximum_files: '클릭하여 파일 추가 이하 최대 개',
        by_clicking_drag_and_drop_maximum_files: '클릭하여 파일 추가 혹은 여기로 드래그 ({{lessCapacity}}이하 최대 {{maxFileCount}}개)',
        get_on: '타 전산 연동 정보',
        get_on_required: '타 전산 연동 필요 여부',
        get_on_code_input: '타 전산 코드 입력',
        other_computers_code_input: '바코드 입력',
        classification_of_other_computer_systems: '타전산구분',
        other_computer_linkage_code: '타전산연동코드',
        other_computer_interconnection_codes_required: '타전산연동코드는 필수 입니다',
        whether_interconnection_with_other_computers_is_necessary: '타전산연동필요여부',
        other_computer_code: '상품바코드',
        goods_barcode_select: '상품 바코드 선택',
        duplicate_goods_barcode_select: '중복 상품 바코드 선택',
        other_computer_code_duplicate: '타전산코드가 중복되었습니다',
        other_computer_codes_required: '타전산코드는 필수 입니다',
        other_computerized_item_code: '타전산품목코드',
        goods_barcode_required: '상품바코드는 필수 입니다',
        sales_code: '발주처코드',
        sales_code_input: '발주처 코드 입력',
        sales_code_required: '발주처 코드는 필수 입니다',
        sales_code_duplicate: '발주처코드가 중복되었습니다',
        other_item_code: '바코드',
        test: '테스트',
        table: '테이블',
        table_area: '테이블 영역',
        significant: '특이사항',
        picking_delivery_statement_printYn: '개별피킹 납품서 출력 여부',
        print: '출력',
        not_print: '미 출력',
        significant_input: '특이사항 입력',
        team_come_id: 'CMS ID',
        team_come_input: 'CMS ID 입력',
        team_come_id_required: 'CMS ID는 필수 입니다',
        file_limit: '파일 개수는 {{fileLimitCount}}개를 넘을 수 없습니다',
        file_data_entry_warning: '파일 내 데이터 오입력 발생 시 등록되지 않으니 다시 한번 확인하시기 바랍니다',
        file_size_limit_per_file: '파일 당 - MB를 넘을 수 없습니다',
        file_upload: '파일 업로드',
        file_upload_status_window: '파일 업로드 상태창',
        file_too_large: '파일 크기가 너무 큽니다',
        file_size_limit: '파일당 {{fileSizeLimit}}MB를 넘을 수 없습니다',
        file_absent: '파일이 없습니다',
        sale_absent: '판매 내역이 없습니다',
        sale_delivery_day: '판매(배송)일',
        sale_conversion_quantity: '판매 시 변환 수량',
        sales_profit_margin_2: '판매 이익율',
        sales_status: '판매 현황',
        sale_price: '판매가',
        sale_date: '판매일',
        sale_price_setting: '판매가 설정',
        sale_price_setting_required: '판매가 설정은 필수 입니다',
        reserved_sale_price_product: '판매가 예약 상품',
        sale_price_ratio: '판매가/율',
        sale_price_application_date: '판매가 적용일',
        sale_price_adjustment: '판매가 조정',
        sale_price_adjustment_including_reserved_product: '판매가 조정 예약중인 상품이 포함되어 있습니다',
        sale_price_or_profit_margin_error: '판매가 혹은 이익율 이 올바르지 않습니다',
        selling_price_required: '판매가는 필수입니다',
        sales_price_setting_classification: '판매가설정구분',
        reservation_for_sale_price: '판매가예약',
        sales_amount_exclusion: '판매금액(VAT제외)',
        sales_quantity: '판매수량',
        popup: '팝업',
        material_code: '품목코드',
        material_name: '품목명',
        popup_area_sales_outlet_search_popup: '팝업 영역 발주처 검색 팝업',
        password_change: '패스워드 변경',
        password_change_button: '패스워드 변경 시 이 버튼을 눌러주세요',
        password_change_completed: '패스워드 변경이 완료 되었습니다',
        password_reset_prompt: '패스워드 초기화를 하시겠습니까',
        password_reset_completed: '패스워드 초기화를 하였습니다',
        password_verification: '패스워드 확인',
        password_incorrect: '패스워드가 올바르지 않습니다',
        password_mismatch_2: '패스워드가 일치하지 않습니다',
        password_match_2: '패스워드가 일치합니다',
        password_required: '패스워드는 필수 입니다',
        enter_password: '패스워드를 입력하여 주십시오',
        please_enter_password: '패스워드를 입력해주세요',
        page_absent: '페이지가 존재하지 않습니다',
        average_order_amount: '평균 주문금액',
        average_selling_price: '평균판매가',
        weekdays: '평일',
        weekdays_closure: '평일 마감',
        no_weekdays: '평일 없음',
        dispose: '폐기',
        scheduled_for_dispose: '폐기 예정',
        scheduled_for_disposal: '폐기예정',
        stock_holding: '재고홀딩',
        disposal_processing: '폐기처리',
        filter: '필터',
        filter_area: '필터 영역',
        filter_code: '필터코드',
        filter_code_length_limit: '필터코드는 {{filterCodeLengthLimit}}자를 넘을 수 없습니다',
        bottom: '하단',
        bottom_reference: '하단 참조 입고예정서 참고',
        down: '하위 카테고리가 있을 경우 카테고리 코드를 삭제 할 수 없습니다',
        piece: '한개 이상 대기업을 등록해 주십시오',
        hangeon: '한건 이라도 실패 있으면 실패 강조 처리',
        korean: '한글 입력은 불가합니다',
        limit: '한도 금액 초과 시에는 주문이 불가능합니다',
        limit_amount: '한도 원 채권잔액 원',
        temporary_limit_adjustment: '한도 임시 조정',
        the_limit_is_temporarily_adjusted: '한도가 임시 조정 되었습니다',
        total_2: '합계',
        total_amount_2: '합계금액',
        total_amount_inclusive_of_tax: '합계금액은 소비세가 포함된 금액입니다',
        delete_virtual_account: '해당 가상계좌를 삭제하시겠습니까',
        non_exposure_of_product_on_scheduled_delivery_date: '해당 기간의 배송예정일에는 선택 된 상품이 노출되지 않습니다',
        delete_menu: '해당 메뉴를 삭제합니다 메뉴 삭제시 하위 메뉴도 삭제 됩니다 진행 하시겠습니까',
        switch_product_require_password: '해당 상품을 {{switchGoodsStatus}} 전환 하시는 경우 비밀번호를 입력해주세요',
        data_irreversibility_after_approval: '해당 승인 이후에는 데이터 원복이 불가하며 가상계좌번호가 다른 발주처에 연동될 수 있습니다',
        no_return_details_in_statement: '해당 정산서에 포함할 반품 내역이 없습니다',
        process_receipt_of_order: '해당 주문건에 대해 접수 처리를 하시겠습니까',
        filter_only_included_orders: '해당 주문에 포함되지 않는 값도 같이 넘어오기 때문에 해당 주문의 상품만 필터링',
        no_assigned_route_for_turn: '해당 회차에 배정된 라우트가 없습니다',
        not_applicable: '해당없음',
        no_individual_picking_paper_available: '해당하는 조건에 출력할 수 있는 개별피킹지가 없습니다',
        no_total_picking_paper_available: '해당하는 조건에 출력할 수 있는 총량피킹지가 없습니다',
        order_qty: '주문수량',
        lot: 'LOT',
        enter_individual_picking_code_to_search: '개별피킹코드를 입력하여 검수할 상품을 조회하세요',
        no_label_available: '해당하는 조건에 출력할 수 있는 라벨이 없습니다 조회하는 센터 기준과 착지가 동일할 수 없습니다',
        view_only_termination_approval_status: '해지 승인 대기 상태만 보기',
        termination_approval_disconnection_of_virtual_account:
            '해지 승인 시 해당 발주처와 가상계좌 번호의 연동이 끊기며 해당 가상계좌의 계좌 잔액이 -원으로 변경됩니다.',
        termination_completed: '해지 완료',
        termination_request_1: '해지 요청',
        termination_status: '해지상태',
        termination_request_2: '해지요청',
        now: '현재',
        current_purchase_profit_rate: '현재 구매 이익율',
        current_password_matches: '현재 패스워드와 동일합니다',
        current_selling_price: '현재판매가',
        home: '홈으로',
        check: '확인',
        proceed_with_care: '확인 후 신중하게 진행',
        confirmation_required: '확인필요',
        confirmed: '확정',
        undisposed_confirmed_quantity: '[미폐기]확정량',
        confirmation_process: '확정 처리',
        confirmation_processor: '확정 처리자',
        post_confirmation_inventory_immediately_reflected: '확정 후 재고수불부에 즉시 반영되며 수정이 불가하오니 다시 한번 확인해주세요.',
        confirmed_closing_date_and_time: '확정마감일시',
        confirmed_date_and_time: '확정일시',
        confirmed_date: '확정일자',
        confirmed_person: '확정자',
        refund_amount: '환불 금액',
        expected_refund_amount_including_request_amount: '환불예정금액 요청금액 포함',
        episode: '회',
        company_name_required: '회사명',
        collection_and_processing_information: '회수 및 처리 정보',
        collection_and_processing_information_details: '회수 및 처리정보',
        collection_shipping_code_self_disposal: '회수 배송 코드 자체폐기',
        select_collection_reason: '회수 사유 선택',
        please_select_a_collection_reason: '회수 사유를 선택해주세요',
        view_recovery_photos_1: '회수 사진 보기',
        no_recovery_photos: '회수 사진이 없습니다',
        collection_quantity_order_unit: '회수 수량 / 주문 단위',
        collection_completed: '회수 완료',
        collection_completed_quantity: '회수 완료 수량',
        collection_request_cancellation: '회수 요청 취소',
        collection_request_deleted_customer_refund_procedure_cancelled: '회수 요청이 삭제되고 고객 환불 절차가 모두 취소되며',
        collection_incoming: '회수 입고',
        collection_receipt: '회수/접수',
        collection_progress_code_collection_completed: '회수 진행 코드 회수완료',
        collection_processing: '회수 처리',
        select_collection_processing_type: '회수 처리 유형 선택',
        please_select_a_collection_processing_type: '회수 처리 유형을 선택해주세요',
        collection_processing_code_partial_complete_complete: '회수 처리 코드 부분완료 완료',
        collection_processing_irreversible_post_processing_reflected_in_inventory: '회수 처리 후에는 수정이 불가하며 재고수불부에 반영됩니다',
        collection_processing_not_done: '회수 처리가 되지 않았습니다',
        collection_cancellation: '회수 취소',
        collection_cancellation_proceed_with_caution:
            '회수 취소 시 배송매니저 회수 리스트에서 즉시 삭제되며, 해당 발주처에 환불이 확정 되오니 신중하게 확인 후 진행하시기 바랍니다.',
        collection_required_quantity: '회수 필요 수량',
        number_of_collections: '회수건수',
        recovery_result: '회수결과',
        view_unprocessed_recovery_results_only: '회수결과 미처리 만 보기',
        collection_manager: '회수매니저',
        select_a_reason_for_recovery: '회수사유 선택',
        view_recovery_photos_2: '회수사진보기',
        recovery_status: '회수상태',
        recovery_status_option: '회수여부',
        select_whether_to_recover: '회수여부를 선택하세요',
        recovery_completed: '회수완료',
        recovery_completed_display: '회수완료 후 회수 처리 결과를 표시',
        recovery_request_immediate_refund: '회수요청(즉시환불)',
        collection_date: '회수일',
        recovering: '회수중',
        cancel_request_during_recovery: '회수중 요청취소',
        cancel_possible_during_recovery: '회수중 체크 활성화 취소 가능',
        recovery_processing_done: '회수처리 되었습니다',
        recovery_processing_type_return_disposal_recovery: '회수처리 유형 양품화 반품 폐기',
        cancellation_of_collection: '회수취소',
        cancellation_of_collection_done: '회수취소 되었습니다',
        recovery_code: '회수코드',
        recovery_code_details: '회수코드 상품 상품명 발주처 회수매니저',
        round: '회차',
        select_print_issue_for_round: '[{{pickingRound}}회차] 이미 발급한 출력 건으로 피킹회차를 선택해주세요',
        register_round: '회차를 등록 해주세요',
        select_round_mandatory: '회차를 필수로 선택해주세요',
        select_at_least_round: '1회차 이상으로 선택해주세요',
        select_up_to_round: '10회차 이하로 선택해주세요',
        mobile_phone_number_entry: '휴대폰번호',
        enter_mobile_phone_number_digits: '휴대폰번호 11자리를 입력해주세요',
        enter_accurate_mobile_phone_number: '휴대폰번호를 정확히 입력하여 주십시오',
        enter_id: 'ID를 입력하여 주십시오',
        excel_download_limit: '{{maxExcelCount}}건 이하만 엑셀 다운로드가 가능합니다',
        enter_up_to_n_digits: 'n자리 이하로 입력하여 주십시오',
        hour: '시',
        time: '시간',
        shipping_management: '출고 관리',
        shipping_wait: '출고 대기',
        shipping_work: '출고 작업',
        shipping_completed: '출고 완료',
        shipping_history_excel_download: '출고 이력 엑셀 다운로드',
        shipping_date: '출고일',
        shipping_history_inquiry: '출고 이력 조회',
        total_shipping_history: '총 {{totalShippingHistory}} 개의 출고 이력',
        empty_page_shipping_history: '출고 이력 내역이 없습니다',
        history: '내역',
        empty_page_order_by_goods_list: '주문이 없습니다.',
        order_date: '주문일',
        view_unprocessed_only: '미처리 내역만 보기',
        inventory_history_inquiry: '재고이력 조회',
        inventory_audit_detail: '재고 조사 상세',
        inventory_audit_code: '재고 조사 코드',
        inventory_audit_date_and_time: '재고 조사 일시',
        inventory_audit_instruction: '재고 조사 지시',
        inventory_no_matching_count: '재고불일치 상품 수',
        inventory_no_matching_ratio: '재고불일치 상품 비율',
        view_no_audit_location_only: '미조사 로케이션만 보기',
        week: '주',
        warning_take_back_delete: '회수 요청이 삭제되며, 취소 후에는 재처리가 불가합니다.',
        shipping: '춢고',
        warning_no_purchase_price_cant_use_y: '매입가가 입력되지 않은 상품은 사용으로 전환 할 수 없습니다.',
        unuse_conversion: '미사용 전환',
        excel_download_unuse_conversion_order_goods: '미사용 전환 상품 주문 내역 엑셀 다운로드',
        image_bulk_upload: '이미지 대량 업로드',
        register_goods: '상품 등록',
        update_goods: '상품 수정',
        purchase_manager_automatic_input: '구매담당자 자동 입력',
        input_specifications_for_order_goods_unit: '상품 주문 단위에 대한 규격을 입력',
        necessary: '필요',
        concealment: '미노출',
        max: '최대',
        each: '개',
        now_price: '현재 판매가',
        please_enter: '입력해주세요',
        include: '포함',
        sales_settlement_adjustment_handling: '매출 정산 조정금 처리',
        info_previous_month_sales_settlement_process_1: '매출정산서의 조정금은 해당 정산서 내역에 반영됨에 따라,',
        info_previous_month_sales_settlement_process_2: "'전월' 기준만 가능하며, 매출반영 Y 로 자동 적용됩니다.",
        view_non_exposure_purchaser: '미노출 브랜드 보기',
        register_or_cancel_favorite: '즐겨찾기 {{favoriteRegisterOrCancel}}완료되었습니다.',
        view_non_exposed_product: '미노출 상품보기',
        not_confirmed: '미확정',
        settlement_adjustment_price: '정산 조정금',
        payment: '결제',
        person_in_charge_of_sales: '발주처 담당자',
        approve: '승인',
        error_message: '에러 메시지',
        file: '파일',
        virtual_account: '가상계좌',
        warning_purchase_order_request_update_1: '발주 요청서 수정 시, 해당 상품의 매입처로 ',
        warning_purchase_order_request_update_2: '*수정된 발주 요청서*',
        warning_purchase_order_request_update_3: '가 발송 됩니다.',
        warning_purchase_order_request_update_4: '발송 후에는 취소할 수 없으니,',
        warning_purchase_order_request_update_5: '확인 후 신중하게 발주 ',
        warning_purchase_order_request_update_6: '하시기 바랍니다.',
        warning_inbound_expected_request_update_1: '입고 예정서 등록 후에는 취소할 수 없으니',
        warning_inbound_expected_request_update_2: '확인 후 신중하게 입고',
        warning_inbound_expected_request_update_3: '부탁드립니다.',
        warning_inbound_expected_request_update_4: '총 입고 예정 수량은 아래 수량 등록하시면 합산되어 표기 됩니다.',
        warning_create_settlement_without_return_goods: '반품 내역을 선택하지 않고, 정산서를 생성하시겠습니까?',
        reflect: '반영',
        not_reflect: '미반영',
        unsettled_return_goods_history: '미정산 반품내역',
        total_return_history: '반품 내역 갯수',
        total_return_amount: '반품 총 금액',
        departure_place: '발송지',
        validate_required_logistic_code_1: '물류코드는 필수입니다.',
        validate_required_logistic_code_2: '물류코드는 1개 이상 필수입니다.',
        validate_change_outbound_date: '출고 변경일은 오늘보다 이후 날짜여야 합니다.',
        re_shipping_order_instruction_complete: '재출고 지시 완료 되었습니다.',
        re_shipping_order_instruction: '재출고 지시',
        notice_to_customer_complete: '고객에게 안내가 완료 된 건입니다.',
        warn_cancel_order_1: '주문 취소 시, 상품을',
        warn_cancel_order_2: '즉시 주문 취소',
        warn_cancel_order_3: '합니다.',
        warn_cancel_order_4: '주문 취소 시',
        warn_cancel_order_5: '자동 환불 ',
        warn_cancel_order_6: '되므로 신중하게',
        warn_cancel_order_7: '확인 후 처리 ',
        warn_cancel_order_8: '하시기 바랍니다.',
        piece_picking_label_printing: '개별피킹 라벨 출력',
        not_need_trunk_plt_label_printing: '간선 PLT 출력이 필요없는 대상입니다. (지선 출고만 있음)',
        search_logistic_code_information: '물류코드 정보 조회',
        empty_page_list: '목록이 존재하지 않습니다.',
        empty_page_shipping_completed: '출고 완료 내역이 없습니다.',
        register_outbound_setting_completed: '출고 설정 등록이 완료되었습니다.',
        setting: '설정',
        picking_zone: '피킹존',
        ignore_picking_zone_inventory: '피킹존 재고 무시',
        check_picking_zone_inventory: '피킹존 재고 확인',
        instruct_shipping_work_completed: '출고 작업 지시 되었습니다.',
        instruct_shipping_work: '출고 작업 지시',
        shipping_setting: '출고 설정',
        empty_page_shipping_wait: '출고 대기 작업이 없습니다.',
        select_picking_turn: '피킹회차 선택',
        create_picking: '피킹 생성',
        picking_round: '피킹 회차',
        picking_round_format_example: 'MMDD-n (예: 1125-1, 1125-2)',
        empty_page_outbound_work: '출고 작업이 없습니다',
        picking_quantity: '피킹 수량',
        print_picking_list_no_outbound_logistics_code: '피킹리스트 출력 - 선택된 출고 물류코드가 없습니다.',
        print_picking_list: '피킹리스트 출력',
        order_registration_completed: '주문 등록 완료되었습니다.',
        sales_channel_code: '판매채널코드',
        sales_channel_name: '판매채널명',
        other_system_sales_channel_code: '타 전산 발주처코드',
        other_system_product_code: '타 전산 상품코드',
        title_2: '타이틀',
        app: '앱',
        folder: '폴더',
        link: '링크',
        child_app: '자식앱',
        monday: '월요일',
        tuesday: '화요일',
        wednesday: '수요일',
        thursday: '목요일',
        friday: '금요일',
        saturday: '토요일',
        sunday: '일요일',
        monday_short: '월',
        tuesday_short: '화',
        wednesday_short: '수',
        thursday_short: '목',
        friday_short: '금',
        saturday_short: '토',
        sunday_short: '일',
        january: '1월',
        february: '2월',
        march: '3월',
        april: '4월',
        may: '5월',
        june: '6월',
        july: '7월',
        august: '8월',
        september: '9월',
        october: '10월',
        november: '11월',
        december: '12월',
        adjustment_inventory_confirmed: '재고 조정 확정',
        ask_adjustment_inventory_confirmed: '재고 조정 확정하시겠습니까?',
        adjustment_inventory_required_quantity: '재고 조정 수량은 0 ({{cancel}})이거나, {{adjustmentQuantity}} 수량으로 처리해 주시기 바랍니다.',
        upload_batch_adjustment_inventory: '재고 조정 일괄 업로드',
        center_parameter: '센터 파라미터',
        no_center_parameter: '센터 파라미터가 없습니다',
        total_goods_selected: '{{totalSelectedGoods}}개 상품 선택됨',
        inventory_audit_confirmation_1: '재고 조사 반영/확정 처리시 재고 조정리스트에 반영되며,',
        inventory_audit_confirmation_2: '손망실 처리',
        inventory_audit_confirmation_3: '로 처리자의 이름과 함께',
        inventory_audit_confirmation_4: '재고수불부에 반영됩니다.',
        inventory_audit_confirmation_5: '확정 이후에는',
        inventory_audit_confirmation_6: '취소가 불가능하며,',
        inventory_audit_confirmation_7: '오처리 시',
        inventory_audit_confirmation_8: '직접 재고 조정을 통해',
        inventory_audit_confirmation_9: '재조정을 해야 하오니',
        inventory_audit_confirmation_10: '신중하게 처리하시기 바랍니다.',
        inventory_audit_confirmation_11: '(미반영시 재고 조사는 종료되지만 결과는 반영되지 않습니다.)',
        inventory_audit_confirmed: '재고 조사 확정 처리',
        success_inventory_audit_confirmed: '재고 조사 확정 처리 성공',
        warn_inventory_investigation_1: '재고 조사를 지시하는 경우 작업자 WEB에 재고조사 지시가 떨어지며,',
        warn_inventory_investigation_2: '센터 입・출고 작업이 모두 중단되오니, 신중하게 지시하시기 바랍니다.',
        success_inventory_investigation_instruction: '재고 조사 지시가 완료 되었습니다.',
        fail_inventory_investigation_instruction: '재고 조사 지시가 실패 되었습니다.',
        in_progress_inventory_investigation_instruction: '재고 조사 진행중 입니다.',
        inventory_investigation_upload: '재고 조사 업로드',
        download_inventory_investigation_upload_form: '재고조사 양식 다운로드',
        inventory_investigation_information_excel_file: '재고 조사 정보 Excel 파일',
        required_purchase_request_form: '발주 요청서 선택 필요',
        confirmed_receiving_document: '입고 확정서',
        scheduled_receiving_document: '입고 예정서',
        scheduled_receiving_document_registration: '입고 예정서 등록',
        hourly_receiving_quantity: '시간당 입고량',
        check_return_detail: '반품 내용 확인',
        return: '반품',
        adjustment_inventory_detail: '재고 조정 상세',
        small: '소',
        success_upload: '업로드가 완료 되었습니다.',
        fail_upload: '업로드에 실패하였습니다.',
        expiration_date_adjustment_preorder_inventory_1: '유통기한 마지노선 변경 시 재고 로스가 발생할 수 있으니,',
        expiration_date_adjustment_preorder_inventory_2: '설정한 기간에 따라 선주문 상품의 가용재고가 차감 됩니다.',
        expiration_date_adjustment_preorder_inventory_3: '다시 한번 신중하게, ',
        expiration_date_adjustment_preorder_inventory_4: '확인 후 진행',
        expiration_date_adjustment_preorder_inventory_5: '하시기 바랍니다.',
        excel_download: '엑셀 다운로드',
        pre_order_inventory_deduction: '선주문 재고차감',
        tax_exemption: '비과세',
        manual_ordering: '수동 발주',
        resend: '재전송',
        exit_delivery_count: '출차횟수',
        designation: '지정',
        success_resend_url: 'URL 재전송을 성공하였습니다.',
        click_for_resend_url: 'URL을 재전송하시려면 전송 버튼을 눌러주세요',
        send_url: 'URL 전송',
        exposure_announcement: '공지사항 노출',
        final_detail_type: '최종 상세유형',
        first_consultation_type: '1차 상담유형',
        first_detail_type: '1차 상세유형',
        claim_content: '클레임 내용',
        claim_amount: '클레임 금액',
        claim_detail: '클레임 상세',
        prompt_claim_quantity: '클레임 수량을 입력하세요',
        claim_quantity: '클레임 수량',
        missing_treatment_classification: '처리 구분 값이 누락됨',
        missing_attribution: '귀책 값 누락',
        missing_recovery_status: '회수여부 값 누락',
        missing_attribution_amount: '귀책금액 값 누락',
        missing_treatment_quantity: '처리 수량 값 누락',
        missing_customer_refund_amount: '발주처 환불 금액 값 누락',
        register_return_exchange: '반품 & 교환 접수',
        success_register_return_exchange: '반품 & 교환 신청이 완료되었습니다.',
        no_delivery: '미배송',
        order_timing: '주문시점',
        tax_goods_include_vat: "'과세' 상품의 경우, 부가세가 포함되어 계산됩니다.",
        processing_return_exchange: '반품 & 교환 처리',
        collection_cancellation_proceed_with_caution_1: '회수 취소 시, 배송매니저 회수 리스트에서',
        collection_cancellation_proceed_with_caution_2: '즉시 삭제되며 해당 발주처에 환불이 확정',
        collection_cancellation_proceed_with_caution_3: '되오니 신중하게',
        collection_cancellation_proceed_with_caution_4: '확인 후 진행',
        collection_cancellation_proceed_with_caution_5: '하시기 바랍니다.',
        counselor_memo_delete: '상담시 메모 삭제',
        counselor_memo: '상담사 메모',
        prompt_memo: '메모할 내용을 입력해주세요.',
        empty_page_counselor_memo_history: '상담사 메모 내역이 없습니다.',
        ask_counselor_memo_delete: '등록된 메모를 삭제하시겠습니까?',
        receipt: '접수',
        approve_return: '반품승인',
        reject: '반려',
        return_exchange_detail: '반품 & 교환 상세',
        return_exchange_goods: '반품 & 교환 상품',
        empty_page_return_exchange_history: '반품 & 교환 내역이 없습니다',
        return_status: '반품상태',
        recovery_request: '회수요청',
        immediate_refund: '즉시환불',
        maximum_memo_prompt_over: '최대 글자수가 초과되어 저장할 수 없습니다(2000자)',
        save_memo: '메모 저장',
        expected_refund_amount: '환불예정금액',
        including_vat_request_amount: '요청금액(VAT포함)',
        request_1: '요청',
        except_1: '외',
        claim: '클레임',
        send_date_time: '발송일시',
        sender: '발송자',
        view_send_screen: '발송 화면 보기',
        success_send_message: '메시지가 발송 되었습니다',
        send_message: '메시지 발송',
        order_cancellation_immediate_1: '주문 취소 시, 상품을 ',
        order_cancellation_immediate_2: '즉시 주문 취소합니다.',
        order_cancellation_immediate_3: '주문 취소 시',
        order_cancellation_immediate_4: '자동 환불',
        order_cancellation_immediate_5: '되므로 신중하게',
        order_cancellation_immediate_6: '확인 후 진행',
        order_cancellation_immediate_7: '하시기 바랍니다.',
        total_urgent_delivery_vehicle_amount: '총 긴급출고 차량비용',
        batch_adjustment_irreversible_warning_1: '일괄 조정 시 데이터 원복이 불가능하므로,',
        batch_adjustment_irreversible_warning_2: '다시 한번 신중하게,',
        batch_adjustment_irreversible_warning_3: '확인 후 진행',
        batch_adjustment_irreversible_warning_4: '하시기 바랍니다.',
        adjustment_fee_processing_impact_1: '조정금 처리 시 조정금액이',
        adjustment_fee_processing_impact_2: '즉시 채권에 반영되며,',
        adjustment_fee_processing_impact_3: '정산서에 반영 청구 되오니',
        adjustment_fee_processing_impact_4: '다시 한번 확인 후 처리하시기 바랍니다.',
        product_adjustment_by_item: '상품별 조정 금액',
        update_contract_information: '계약정보 수정',
        pre_pay: '선불',
        post_pay: '후불',
        notice_sales_contract_type_update_1: '발주처 계약형태 수정에 따른 내용에 대해 반드시',
        notice_sales_contract_type_update_2: '사전 확인 후 진행',
        notice_sales_contract_type_update_3: '하시기 바랍니다.',
        select_japanese: '선택(일본어)',
        sprout_customer: '새싹 고객',
        weekend_closure_time: '주말 마감 시간',
        weekday_closure_time: '평일 마감 시간',
        order_info: '주문 정보',
        modify_information: '정보 수정',
        temporary_credit_limit: '임시 여신 한도',
        limit_1: '한도',
        customer_contact_name_1: '발주처 담당자 1) 이름',
        customer_contact_phone_1: '발주처 담당자 1) 연락처',
        customer_contact_email_1: '발주처 담당자 1) 이메일',
        customer_contact_name_2: '발주처 담당자 2) 이름',
        customer_contact_phone_2: '발주처 담당자 2) 연락처',
        customer_contact_email_2: '발주처 담당자 2) 이메일',
        transaction_statement_receipt_time: '거래명세서 수취 시간',
        contract_start_date: '계약 시작일',
        departure_center_id: '출차센터 ID',
        order_id: '주문 ID',
        order_content_2: '주문 내용',
        sales_transfer_irreversible_1: '매출이관 완료 시',
        sales_transfer_irreversible_2: '원복은 불가하며,',
        sales_transfer_irreversible_3: '수관 발주처 정산 내 반영, 청구 되오니,',
        sales_transfer_irreversible_4: '다시 한 번 확인 후 처리하시기',
        sales_transfer_irreversible_5: '바랍니다.',
        sales_transfer_max_logistic_code: '{{salesTransferRound}}회 이관 처리 시, 최대 {{salesTransferLogisticCodeLimit}}개의 물류코드만 가능합니다',
        receive_sales_select: '수관 발주처 선택',
        warn_upload_batch_sales_price_reservation_1: '잦은 대량 데이터 업로드는 서버 부하를 일으킬 수 있으며,',
        warn_upload_batch_sales_price_reservation_2: '고객 주문 또는 출고에 영향을 미칠 수 있으니 한번 더 파일을 확인하시기 바랍니다.',
        warn_upload_batch_sales_price_reservation_3: '이미 판매가 예약이 되어 있는 상품의 경우 최종 업로드 기준으로 변경됩니다.',
        contract_renewal_processing_warning_1: '재계약 처리 시에는',
        contract_renewal_processing_warning_2: '신규 가상계좌번호가 부여되며,',
        contract_renewal_processing_warning_3: '기존 계약정보가 원복되오니',
        contract_renewal_processing_warning_4: '반드시 재확인',
        contract_renewal_processing_warning_5: '하시기 바랍니다.',
        max_code_group_name: '코드 그룹 명은 {{maxCodeGroupName}}자를 넘을 수 없습니다.',
        password_2: '패스워드',
        re_enter_password: '재입력 패스워드',
        select_purchase_manager: '구매담당자 선택',
        upload_failure: '업로드 실패',
        code_id: '코드 ID',
        code_group_id: '코드 그룹 ID',
        required_code_id: '코드 ID는 필수입니다.',
        code_group_id_length_limit: '코드 그룹 ID는 {{codeGroupIdLengthLimit}}자를 넘을 수 없습니다.',
        code_group_name_length_limit: '코드 그룹 명은 {{codeGroupNameLengthLimit}}자를 넘을 수 없습니다.',
        chain_code_length_limit: '연관 코드는 {{chainCodeLengthLimit}}자를 넘을 수 없습니다.',
        korean_code_name_required: '코드 명(한국어)은 필수입니다.',
        japanese_code_name_required: '코드 명(일본어)은 필수입니다.',
        korean_code_display_name_length_limit: '코드 노출 명(한국어)은 {{koreanCodeDisplayNameLengthLimit}}자를 넘을 수 없습니다.',
        japanese_code_display_name_length_limit: '코드 노출 명(일본어)은 {{japaneseCodeDisplayNameLengthLimit}}자를 넘을 수 없습니다.',
        add_code: '코드 추가',
        korean_code_name: '코드 명(한국어)',
        japanese_code_name: '코드 명(일본어)',
        korean_display_code_name: '코드 노출 명(한국어)',
        japanese_display_code_name: '코드 노출 명(일본어)',
        add_code_group: '코드그룹 추가',
        modify_code_group: '코드그룹 수정',
        code_group_name: '코드 그룹 명',
        code_group_explain: '코드 그룹 설명',
        code_group_explain_length_limit: '코드 그룹 설명은 {{codeGroupExplainLengthLimit}}자를 넘을 수 없습니다.',
        code_group_id_required: '코드 그룹 ID는 필수입니다.',
        korean_code_group_name_required: '코드 그룹 명(한국어)은 필수입니다.',
        japanese_code_group_name_required: '코드 그룹 명(일본어)은 필수입니다.',
        korean_code_group_explain_required: '코드 그룹 설명(한국어)은 필수입니다.',
        japanese_code_group_explain_required: '코드 그룹 설명(일본어)은 필수입니다.',
        statement: '정산',
        total_sales_amount_percentage: '전체 발주처 매출액의 {{totalSalesAmountPercentage}}',
        months: '개월',
        post_number_is_required: '우편번호는 필수입니다',
        postal_code_must_be_7_digits: '우편번호는 7자리만 입력 가능합니다',
        adjustment_inventory: '재고 조정',
        enter: '입력',
        select_return_process_result: '반품 처리 결과 선택',
        circulation_sales: '유통 매출',
        logistic_sales: '물류 매출',
        no_settlement: '정산 없음',
        monthly_settlement: '월 단위 정산',
        monthly_installment_settlement: '월 분할 정산',
        next_month: '익월',
        not_received: '미입고',
        terminated: '종결',
        last_short: '말',
        ten_thousand_currency_unit: '만엔',
        location_row: '열',
        location_col: '단',
        select_file: '파일 선택',
        empty_selected_file: '선택된 파일이 없습니다.',
        network_error: '네트워크 에러',
        cannot_connect_server: '서버와 연결할 수 없습니다. 잠시 후 다시 시도해 주십시오.',
        split_string_info: '구분자(,)로 다중검색',
        barcode: '상품 바코드',
        enter_barcode: '상품 바코드 입력',
        enter_sku_code: 'SKU 코드 입력',
        enter_goodsIrCd: '센터관리코드 입력',
        lot_no: 'LOT',
        lot_input: 'LOT 번호 입력',
        order_client_cd: '발주처코드',
        order_client_nm: '발주처명',
        mall_order_no: '몰 주문 번호',
        slip_no: '전표 번호',
        ship_scheduled_dt: '출하 예정일',
        delivery_request_dt: '지정납품일',
        delivery_request_tm: '지정 납품 시간',
        delivery_nm: '배송지명',
        delivery_zip: '배송지 우편번호',
        delivery_prefecture: '도도부현',
        delivery_addr_rest: '상세주소',
        delivery_tel: '배송지 전화번호',
        order_goods_barcode: '바코드',
        product_nm: '상품명',
        order_upload_quantity: '수량',
        order_upload_unit_price: '단가',
        total_price: '상품금액 계',
        processing_div: '가공 구분 ※ 라벨 부착의 경우 1 입력',
        note_1: '기사란 1',
        note_2: '기사란 2',
        sku_code: 'SKU 코드',
        goodsIrCd: '센터 관리코드',
        bulk_inspection_select_items: '일괄검수처리할 항목을 선택해주세요.',
        bulk_inspection_confirm: '선택하신 주문을 일괄 검수 처리합니다.\n정말 진행하시겠습니까?',
        bulk_inspection_success: '선택된 {{count}}개 주문의 일괄검수처리가 완료되었습니다.',
        bulk_inspection_failed: '일괄검수처리 실패: {{error}}',
        address_valid_yn: '주소 검증 실패 주문만 보기',
        address_edit: '주소 변경',
        address_edit_success: '주소 변경 완료 되었습니다.',
        address_valid_warning: '출고예정일이 오늘 이전인 주문들은 주소 검증이 되지 않습니다.\n 주소 검증을 진행하시겠습니까?',
    },
    code: {
        brd_stl_stt_cd_ny: '미확정',
        brd_stl_stt_cd_cf: '확정',
        brd_stl_stt_cd_er: '정산에러',
        brd_stl_typ_cd_dist: '유통매출',
        brd_stl_typ_cd_logi: '물류매출',
        brd_stl_typ_cd_none: '정산없음',
        gd_typ_e: '전용',
        gd_typ_g: '범용',
        invn_typ_day: '일재고',
        invn_typ_direct: '직송',
        invn_typ_keep: '보관재고',
        gd_tmp_typ_c: '냉장',
        gd_tmp_typ_f: '냉동',
        gd_tmp_typ_r: '실온',
        orgn_typ_d: '일본산',
        orgn_typ_i: '수입산',
        orgn_typ_o: '기타',
        sls_stt_bfe: '종료임박',
        sls_stt_con: '계약중',
        sls_stt_end: '종료',
        sls_stt_stp: '이용정지',
        sls_rtt_asign: '배정',
        sls_rtt_unasign: '미배정',
        gd_use_typ_end: '종결',
        gd_use_typ_unuse: '미사용',
        gd_use_typ_use: '사용',
        nation_ae: '아랍에미리트', // united arab emirates
        nation_am: '미국', // USA
        nation_an: '아르헨티나', // Argentina
        nation_as: '오스트리아', // Austria
        nation_au: '호주', // オーストラリア
        nation_bg: '벨기에', // Belgium
        nation_br: '바레인', // Bahrain
        nation_bz: '브라질', // brazil
        nation_ca: '캐나다', // Canada
        nation_cb: '콜롬비아', // Colombia
        nation_ch: '칠레', // Chile
        nation_cn: '중국', // china
        nation_cr: '코스타리카', // Costa Rica
        nation_dm: '덴마크', // Denmark
        nation_dn: '도미니카', // dominica
        nation_eg: '이집트', // Egypt
        nation_etc: '외국산', // 外国産
        nation_fg: '피지', // Fiji
        nation_fl: '핀란드', // Finland
        nation_fr: '프랑스', // france
        nation_gm: '독일', // germany
        nation_gn: '기니', // Guinea
        nation_gr: '그리스', // Greece
        nation_hk: '홍콩', // Hong Kong
        nation_id: '인도', // India
        nation_idn: '인도네시아', // Indonesia
        nation_il: '아일랜드', // Ireland
        nation_ir: '이란', // Iran
        nation_is: '이스라엘', // Israel
        nation_it: '이탈리아', // Italy
        nation_jp: '일본', // japan
        nation_mc: '멕시코', // Mexico
        nation_mgc: '마다가스카르', // Madagascar
        nation_mn: '모나코', // monaco
        nation_mr: '모로코', // morocco
        nation_ms: '말레이시아', // malaysia
        nation_mt: '모리타니아', // mauritania
        nation_my: '미얀마', // Myanmar
        nation_nd: '네덜란드', // Netherlands
        nation_ng: '나이지리아', // Nigeria
        nation_nw: '노르웨이', // Norway
        nation_nz: '뉴질랜드', // New Zealand
        nation_pc: '파키스탄', // Pakistan
        nation_pf: '태평양', // Pacific
        nation_pfc: '태평양', //
        nation_pg: '파라과이', // Paraguay
        nation_pl: '폴란드', // Poland
        nation_pp: '필리핀', // Philippines
        nation_pr: '페루', // peru
        nation_pt: '포르투갈', // Portugal
        nation_rsa: '남아프리카공화국', // south africa
        nation_ru: '러시아', // russia
        nation_sb: '세르비아', // Serbia
        nation_sd: '사우디아라비아', // Saudi Arabia
        nation_sea: '원양', // 遠洋
        nation_sg: '세네갈', // Senegal
        nation_sgp: '싱가포르', // singapore
        nation_sl: '스리랑카', // sri lanka
        nation_sp: '스페인', // spain
        nation_ss: '스위스', // Swiss
        nation_sw: '스웨덴', // sweden
        nation_tk: '튀르키예', // Turkye
        nation_tl: '태국', // thailand
        nation_ts: '튀니지', // Tunisia
        nation_tw: '대만', // taiwan
        nation_ub: '우즈베키스탄', // Uzbekistan
        nation_uk: '영국', // England
        nation_vt: '베트남', // Vietnam
        brd_stat_ei: '종료임박',
        brd_stat_en: '종료',
        brd_stat_st: '정상',
        sls_ctt_postpay: '후불',
        sls_ctt_prepay: '선불',
        pc_grnt_typ_e: '종료',
        pc_grnt_typ_i: '종료임박',
        pc_grnt_typ_n: '정상',
        pc_grnt_typ_none: '상태없음',
        pr_stt_direct: '자체배송',
        pr_stt_ic: '입고완료',
        pr_stt_if: '입고확정',
        pr_stt_ik: '입고확인',
        pr_stt_iw: '입고대기',
        pr_stt_pr: '발주요청',
        pr_stt_px: '발주취소',
        rtrn_prog_ab: '폐기처리',
        rtrn_prog_rx: '반품취소',
        rtrn_prog_rr: '반품접수',
        rtrn_prog_rc: '반품요청(확정)',
        rtrn_typ_bd: '상품 불량',
        rtrn_typ_bk: '상품 파손',
        rtrn_typ_sp: '유통기한 경과',
        pc_stl_typ_cf: '확정완료',
        pc_stl_typ_ny: '미확정',
        bond_pay_stt_npaid: '미납',
        bond_pay_stt_paid: '상환',
        crdt_stt_cd_e: '종료',
        crdt_stt_cd_n: '정상',
        crdt_stt_cd_s: '정지',
        adj_price_category_bond_adj: '채권조정',
        adj_price_category_claim: '클레임',
        adj_price_category_coast: '비용청구',
        adj_price_category_etc: '기타',
        adj_price_category_purchase: '사입비',
        adj_price_category_quick: '퀵비',
        adj_price_category_quick_purchase: '퀵/사입',
        adj_price_category_sales_adj: '매출조정',
        sbjct_rspns_center_mng: '센터관리자',
        sbjct_rspns_consultant: '상담원',
        sbjct_rspns_dlvr_mng: '배송매니저',
        sbjct_rspns_inbound: '입고지센터',
        sbjct_rspns_logistics: '물류사',
        sbjct_rspns_outbound: '출차지센터',
        sbjct_rspns_pc_mng: '구매담당자',
        sbjct_rspns_purchase: '브랜드',
        sbjct_rspns_sales: '발주처',
        sbjct_rspns_sales_mng: '영업담당자',
        sls_stl_typ_cf: '확정완료',
        sls_stl_typ_er: '정산에러',
        sls_stl_typ_ff: '강제확정',
        sls_stl_typ_ny: '미확정',
        po_inb_stt_fi: '강제입고',
        po_inb_stt_mi: '미입고',
        po_inb_stt_ni: '정상입고',
        po_inb_stt_pi: '부분입고',
        rqsts_bad_02: '상품불량',
        rqsts_bad_break: '상품불량 파손',
        rqsts_brk_crm_2: '파손',
        rqsts_chn_mind: '단순변심',
        rqsts_cop_crm_2: '전산문의',
        rqsts_cor_dlvr_02: '대응배송',
        rqsts_cre_crm_2: '결제문의',
        rqsts_dlvr_crm_2: '배송문의',
        rqsts_dmg_py_2: '재화파손',
        rqsts_doc_crm_2: '서류요청',
        rqsts_dor_lck_2: '출입문미시건',
        rqsts_err_code_02: '에러코드',
        rqsts_err_stack_02: '오적재',
        rqsts_error: '오배송',
        rqsts_etc: '기타',
        rqsts_etc_02: '기타문의',
        rqsts_expired: '유통기한',
        rqsts_miss: '미배송',
        rqsts_no_st_crm2: '미입고',
        rqsts_open_clo_2: '냉장고개폐',
        rqsts_ord_crm_02: '발주문의',
        rqsts_over_st_2: '과입고',
        rqsts_pro_crm_2: '제품문의',
        rqsts_sup_data_02: '증빙자료',
        rqsts_unrecover2: '미회수',
        rqsts_wrg_ord_2: '오발주',
        rqsts_wrg_sto_2: '오입고',
        tkbck_prog_tc: '회수완료',
        tkbck_prog_tg: '회수중',
        tkbck_prog_tx: '회수취소',
        tkbck_prcsn_done: '회수정상종료',
        tkbck_prcsn_fc: '완료',
        tkbck_prcsn_n: '미처리',
        tkbck_prcsn_pc: '부분완료',
        tkbck_prcsn_r: '대기중',
        tkbck_inb_ab: '폐기',
        tkbck_inb_gq: '양품화',
        tkbck_inb_qw: '양품대기',
        tkbck_inb_ret: '반품',
        tkbck_dlv_ab: '자체폐기',
        tkbck_dlv_c: '센터회수',
        mdlml_inb_stt_ic: '입고완료',
        mdlml_inb_stt_in_dlv: '배송중',
        mdlml_inb_stt_iw: '입고대기',
        mdlml_inb_stt_prtl_dlv: '부분배송',
        mdlml_inb_stt_xi: '미입고',
        ord_prog_dc: '배송완료',
        ord_prog_dd: '배송지연',
        ord_prog_dw: '배송중',
        ord_prog_oc: '주문확정',
        ord_prog_or: '주문접수',
        ord_prog_ox: '주문취소',
        ord_prog_pd: '부분배송',
        ord_prog_sw: '출고중',
        ord_prog_pc: '패킹완료',
        ord_prog_sc: '출고완료',
        ord_prog_address_fail: '주소오류',
        ord_cancel_ok: '정상',
        ord_cancel_ox: '전체취소',
        ord_cancel_pc: '부분취소',
        outb_stt_e: '미출',
        outb_stt_el: '미상차',
        outb_stt_k: '확인필요',
        outb_stt_n: '정상',
        outb_stt_pd: '부분배송',
        outb_stt_q: '선출고',
        unknown_error: '알 수 없는 오류',
        outb_stt_ro: '재출고',
        outb_stt_x: '취소',
        outb_typ_emrg: '긴급출고',
        outb_typ_last: '지선',
        outb_typ_mid: '간선',
        issu_src_e: '미출',
        issu_src_el: '미상차',
        issu_src_k: '확인필요',
        issu_src_n: '정상',
        issu_src_pd: '부분배송',
        issu_src_q: '선출고',
        issu_src_ro: '재출고',
        issu_src_x: '취소',
        center_issu_e: '긴급출고',
        center_issu_o: '출고지시',
        center_issu_r: '요청취소',
        center_issu_ro: '재출고지시',
        center_issu_x: '주문취소',
        issu_prcsn_cr: '고객요청',
        issu_prcsn_dd: '배송지연',
        issu_prcsn_et: '기타',
        issu_prcsn_gb: '상품불량,파손',
        issu_prcsn_ie: '재고부족',
        invn_adjs_typ_ab: '폐기',
        invn_adjs_typ_defective: '불량',
        invn_adjs_typ_los: '손망실 처리',
        invn_adjs_typ_ml: '미상차',
        invn_adjs_typ_rcv: '손망실복구',
        invn_adjs_typ_shl: '유통기한 조정',
        invn_adjs_typ_lot: 'LOT번호 수정',
        invnsu_prog_c: '완료',
        invnsu_prog_f: '확정',
        invnsu_prog_w: '진행중',
        invn_prcsn_ab: '폐기',
        invn_prcsn_ci: '창간입고',
        invn_prcsn_co: '창간출고',
        invn_prcsn_defective: '불량',
        invn_prcsn_in: '입고',
        invn_prcsn_los: '손망실 처리',
        invn_prcsn_mov: '이동',
        invn_prcsn_out: '출고',
        invn_prcsn_rcv: '손망실복구',
        invn_prcsn_ret: '반품',
        invn_prcsn_shl: '유통기한 조정',
        invn_prcsn_tb: '회수',
        lct_typ_bd: '조정존',
        lct_typ_db: '분배존',
        lct_typ_et: '기타',
        lct_typ_in: '입고존',
        lct_typ_jb: '작업존',
        lct_typ_kp: '보관존',
        lct_typ_mv: '이동존',
        lct_typ_ot: '출고존',
        lct_typ_pk: '피킹존',
        lct_typ_rt: '반품존',
        lct_typ_tk: '회수존',
        tm_dlv_stat_dlv_cpl: '배송완료',
        tm_dlv_stat_in_dlv: '배송중',
        tm_dlv_stat_inb_wait: '입차대기중',
        tm_dlv_stat_load_inspc: '상차검수중',
        tm_dlv_stat_load_wait: '상차대기중',
        dlv_ml_last: '지선',
        dlv_ml_mid: '간선',
        tm_biz_type_prsnl: '개인',
        tm_biz_type_trnsp: '운수사',
        tm_cntr_stat_cntr_end: '계약종료',
        tm_cntr_stat_under_cntr: '계약중',
        stlprg_mnt_next_mth: '익월',
        stand_dt_1: '1',
        stand_dt_10: '10',
        stand_dt_15: '15',
        stand_dt_20: '20',
        stand_dt_25: '25',
        stand_dt_5: '5',
        stand_dt_last: '말일',
        cnsln_typ_cd_claim: '클레임',
        cnsln_typ_cd_common: '일반',
        cnsln_typ_cd_issue: '출고이슈',
        cnsln_typ_cd_msg: '문자발송',
        cnsln_typ_cd_recall: '반품/교환',
        cnsln_typ_cd_urgnt_dlvr: '긴급출고',
        crm_gnr_inq_break_crm_01: '파손',
        crm_gnr_inq_comp_crm_01: '전산문의',
        crm_gnr_inq_cr_dlvr_1: '대응배송',
        crm_gnr_inq_cred_crm_01: '결제문의',
        crm_gnr_inq_dlvr_crm_01: '배송문의',
        crm_gnr_inq_dlvr_rt: '배송 • 회수 문의',
        crm_gnr_inq_dmg_py_01: '재화파손',
        crm_gnr_inq_docu_crm_01: '서류요청',
        crm_gnr_inq_door_lo_1: '출입문미시건',
        crm_gnr_inq_er_code_1: '에러코드',
        crm_gnr_inq_err_st_1: '오적재',
        crm_gnr_inq_etc: '기타 문의',
        crm_gnr_inq_etc_01: '기타문의',
        crm_gnr_inq_goods_inq: '상품 문의',
        crm_gnr_inq_no_st_cr_1: '미입고',
        crm_gnr_inq_open_cl_1: '냉장고개폐',
        crm_gnr_inq_ord_crm_01: '발주문의',
        crm_gnr_inq_ord_stl: '주문 • 정산 문의',
        crm_gnr_inq_over_st_1: '과입고',
        crm_gnr_inq_prod_crm_01: '제품문의',
        crm_gnr_inq_sup_da_01: '증빙자료',
        crm_gnr_inq_sys: '시스템 문의',
        crm_gnr_inq_unrecover_01: '미회수',
        crm_gnr_inq_wng_or_1: '오발주',
        crm_gnr_inq_wng_st_1: '오입고',
        crm_dtl_ty_bad: '상품불량',
        crm_dtl_ty_bad_pack: '포장불량',
        crm_dtl_ty_break: '상품파손',
        crm_dtl_ty_break_crm: '파손',
        crm_dtl_ty_comp_crm: '전산문의',
        crm_dtl_ty_cor_dlvr: '대응배송',
        crm_dtl_ty_cred_crm: '결제문의',
        crm_dtl_ty_dlvr_crm: '배송문의',
        crm_dtl_ty_dly_dlvr: '지연배송',
        crm_dtl_ty_dmg_pry: '재화파손',
        crm_dtl_ty_docu_crm: '서류요청',
        crm_dtl_ty_door_lock: '출입문미시건',
        crm_dtl_ty_err_code: '에러코드',
        crm_dtl_ty_err_ln_bd: '여신・채권 오류',
        crm_dtl_ty_err_ord: '주문불가 오류',
        crm_dtl_ty_err_price: '정산금액 오류',
        crm_dtl_ty_err_recall: '오회수',
        crm_dtl_ty_err_stack: '오적재',
        crm_dtl_ty_etc: '기타',
        crm_dtl_ty_expired_dt: '유통기한',
        crm_dtl_ty_misdlvr: '오배송',
        crm_dtl_ty_no_st_cr: '미입고',
        crm_dtl_ty_open_close: '냉장고개폐',
        crm_dtl_ty_ord_crm: '발주문의',
        crm_dtl_ty_over_st: '과입고',
        crm_dtl_ty_prod_crm: '제품문의',
        crm_dtl_ty_sup_da: '증빙자료',
        crm_dtl_ty_undlvr: '미배송',
        crm_dtl_ty_unrecover: '미회수',
        crm_dtl_ty_wrg_ord: '오발주',
        crm_dtl_ty_wrg_st: '오입고',
        return_stt_cd_approve: '반품승인',
        return_stt_cd_receipt: '접수',
        return_stt_cd_reject: '반려',
        prcsn_stt_cd_done: '완료',
        prcsn_stt_cd_incomplete: '미완료',
        prcsn_stt_cd_rc: '요청취소',
        crm_process_type_e: '교환',
        crm_process_type_r: '반품',
        crm_type_basc_ask: '일반문의',
        crm_type_break_bad: '상품 파손 • 불량',
        crm_type_claim_ask: '클레임',
        crm_type_dlvr_rt: '배송 • 회수',
        crm_type_etc_ask: '기타',
        crm_type_ord_stl: '주문 • 정산',
        noti_state_noti: '공지중',
        noti_state_noti_end: '공지 종료',
        notice_ctg_brand_cal: '채권•정산',
        notice_ctg_etc: '기타',
        notice_ctg_goods: '상품',
        notice_ctg_ord_deli: '주문•배송',
        notice_ctg_system: '시스템',
        grnt_typ_cash: '현금',
        grnt_typ_credit: '신용',
        grnt_typ_pgrnt: '이행보증보험',
        tm_dlv_cpl_stat_dlv_cpl: '배송완료',
        tm_dlv_cpl_stat_in_dlv: '배송중',
        tm_dlv_cpl_stat_no_dlv: '미배송',
        tm_dlv_cpl_stat_prtl_dlv: '부분배송',
        bond_typ_cd_adj: '조정금',
        bond_typ_cd_en: '해지',
        bond_typ_cd_in: '입금',
        bond_typ_cd_mig: '매출이관',
        bond_typ_cd_out: '출금',
        bond_typ_cd_st: '생성',
        all: 'all',
        canceled: 'canceled',
        region: 'region',
        select_region: 'select_region',
        outbound_complete_processing: 'outbound_complete_processing',
        selected_orders_outbound_complete_processing: 'selected_orders_outbound_complete_processing',
        outbound_complete_processing_under_conditions: 'outbound_complete_processing_under_conditions',
        sales_partner: 'sales_partner',
        select_sales_partner: 'select_sales_partner',
        // select_area: '権域選択',
        outbound_complete_processing_according_to_selected_conditions: 'outbound_complete_processing_according_to_selected_conditions',
        completion: 'completion',
        parcel: '택배',
        truck: '트럭',
        ft20: '20FT',
        ft40: '40FT',
        invn_splm_stt_c: '보충 완료',
        invn_splm_stt_o: '보충 지시',
        invn_splm_stt_r: '보충 대기',
        inb_method_typ_receipt_official: '정식입고',
        inb_method_typ_rt_vendor: '거래처 반품',
        inb_method_typ_rt_amazon: '아마존 반품',
        inb_method_typ_rt_jojo: '조조 반품',
        inb_method_typ_rt_popup: '팝업 반품',
        inb_method_typ_rt_head_of: '본사 반품',
        inb_method_typ_rt_qt: '큐텐 반품',
    },
}
